@charset "UTF-8";
:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

html {
  font-family: sans-serif; }

body {
  margin: 0; }

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
menu,
nav,
section,
summary {
  display: block; }

audio,
canvas,
progress,
video {
  display: inline-block;
  vertical-align: baseline; }

audio:not([controls]) {
  display: none;
  height: 0; }

[hidden],
template {
  display: none; }

a {
  background-color: transparent; }

a:active,
a:hover {
  outline: 0; }

abbr[title] {
  border-bottom: 1px dotted; }

b,
strong {
  font-weight: bold; }

dfn {
  font-style: italic; }

h1 {
  font-size: 2em;
  margin: 0.67em 0; }

small {
  font-size: 80%; }

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline; }

sup {
  top: -0.5em; }

sub {
  bottom: -0.25em; }

img {
  border: 0; }

svg:not(:root) {
  overflow: hidden; }

figure {
  margin: 1em 40px; }

hr {
  box-sizing: content-box;
  height: 0; }

pre {
  overflow: auto; }

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0; }

button {
  overflow: visible; }

button,
select {
  text-transform: none; }

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer; }

button[disabled],
html input[disabled] {
  cursor: default; }

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0; }

input {
  line-height: normal; }

input[type='checkbox'],
input[type='radio'] {
  box-sizing: border-box;
  padding: 0; }

input[type='number']::-webkit-inner-spin-button, input[type='number']::-webkit-outer-spin-button {
  height: auto; }

input[type='search'] {
  -webkit-appearance: textfield;
  box-sizing: content-box; }
  input[type='search']::-webkit-search-cancel-button, input[type='search']::-webkit-search-decoration {
    -webkit-appearance: none; }

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em; }

legend {
  border: 0;
  padding: 0; }

textarea {
  overflow: auto; }

optgroup {
  font-weight: bold; }

table {
  border-collapse: collapse;
  border-spacing: 0; }

td,
th {
  padding: 0; }

body {
  font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--wbu-font-weight-regular);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility; }

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0; }

button {
  border-radius: 0; }

[data-z-counter] {
  z-index: 0; }

[data-z-counter='0'] {
  z-index: auto; }

._santa-preview-container_101pd_194 html,
._santa-preview-container_101pd_194 body,
._santa-preview-container_101pd_194 div,
._santa-preview-container_101pd_194 span,
._santa-preview-container_101pd_194 applet,
._santa-preview-container_101pd_194 object,
._santa-preview-container_101pd_194 iframe,
._santa-preview-container_101pd_194 h1,
._santa-preview-container_101pd_194 h2,
._santa-preview-container_101pd_194 h3,
._santa-preview-container_101pd_194 h4,
._santa-preview-container_101pd_194 h5,
._santa-preview-container_101pd_194 h6,
._santa-preview-container_101pd_194 p,
._santa-preview-container_101pd_194 blockquote,
._santa-preview-container_101pd_194 pre,
._santa-preview-container_101pd_194 a,
._santa-preview-container_101pd_194 abbr,
._santa-preview-container_101pd_194 acronym,
._santa-preview-container_101pd_194 address,
._santa-preview-container_101pd_194 big,
._santa-preview-container_101pd_194 cite,
._santa-preview-container_101pd_194 code,
._santa-preview-container_101pd_194 del,
._santa-preview-container_101pd_194 dfn,
._santa-preview-container_101pd_194 em,
._santa-preview-container_101pd_194 font,
._santa-preview-container_101pd_194 img,
._santa-preview-container_101pd_194 ins,
._santa-preview-container_101pd_194 kbd,
._santa-preview-container_101pd_194 q,
._santa-preview-container_101pd_194 s,
._santa-preview-container_101pd_194 samp,
._santa-preview-container_101pd_194 small,
._santa-preview-container_101pd_194 strike,
._santa-preview-container_101pd_194 strong,
._santa-preview-container_101pd_194 sub,
._santa-preview-container_101pd_194 sup,
._santa-preview-container_101pd_194 tt,
._santa-preview-container_101pd_194 var,
._santa-preview-container_101pd_194 b,
._santa-preview-container_101pd_194 u,
._santa-preview-container_101pd_194 i,
._santa-preview-container_101pd_194 center,
._santa-preview-container_101pd_194 dl,
._santa-preview-container_101pd_194 dt,
._santa-preview-container_101pd_194 dd,
._santa-preview-container_101pd_194 ol,
._santa-preview-container_101pd_194 ul,
._santa-preview-container_101pd_194 li,
._santa-preview-container_101pd_194 fieldset,
._santa-preview-container_101pd_194 form,
._santa-preview-container_101pd_194 label,
._santa-preview-container_101pd_194 legend,
._santa-preview-container_101pd_194 table,
._santa-preview-container_101pd_194 caption,
._santa-preview-container_101pd_194 tbody,
._santa-preview-container_101pd_194 tfoot,
._santa-preview-container_101pd_194 thead,
._santa-preview-container_101pd_194 tr,
._santa-preview-container_101pd_194 th,
._santa-preview-container_101pd_194 td,
._santa-preview-container_101pd_194 nav,
._santa-preview-container_101pd_194 button,
._santa-preview-container_101pd_194 section,
._santa-preview-container_101pd_194 header,
._santa-preview-container_101pd_194 footer,
._santa-preview-container_101pd_194 title {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: baseline;
  background: transparent; }

._sortable-list-item__dropzone_101pd_269 {
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--dropZoneSize) * 1px); }

._sortable-list-item__dropzone_101pd_269::before {
  display: none;
  content: '';
  position: absolute;
  left: calc(var(--nestingLevel) * 24px);
  right: 0;
  height: 2px;
  background: #116dff; }

._sortable-list-item__dropzone_after_101pd_284 {
  bottom: 0; }

._sortable-list-item__dropzone_before_101pd_287 {
  top: -2px; }

._sortable-list-item__dropzone_101pd_269:first-child ._sortable-list-item__dropzone_before_101pd_287 {
  top: 0; }

._sortable-list-item__dropzone_after_101pd_284::before {
  bottom: 0; }

._sortable-list-item__dropzone_before_101pd_287::before {
  top: 0; }

._sortable-list-item__dropzone_drop_101pd_299::before {
  display: block; }

._sortable-list-item_101pd_269._sortable-list-item_edit-state_101pd_302 {
  display: flex;
  align-items: center;
  background-color: #d6e6fe;
  padding: 6px 18px 6px 18px;
  height: 36px; }

._sortable-list-item_edit-state__input_101pd_309._input-container_101pd_309 {
  width: calc(100% - 36px); }

._sortable-list-item_edit-state__input_101pd_309._input-container_101pd_309 ._input_101pd_309 {
  background: #fff !important;
  height: 24px !important;
  font-size: 14px !important;
  color: #3b4057;
  border-radius: 4px; }

._sortable-list-item_edit-state__button_101pd_319 {
  width: 54px;
  flex: 0;
  margin: 0 0 0 6px !important;
  padding: 6px 24px !important; }

._sortable-list-item__suffix_101pd_325 {
  flex: 0;
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 6px; }
  ._sortable-list-item__suffix_101pd_325:hover {
    cursor: pointer; }

._sortable-list-item__context-menu-action_101pd_335 {
  display: flex; }

._sortable-list-item__context-menu-action-icon_101pd_338 {
  width: 20px;
  flex: content 0 0; }

._sortable-list-item__context-menu-action-text_101pd_342 {
  flex: 1; }

._sortable-list-item__context-menu-action-icon_101pd_338 > * {
  fill: #3b4057 !important;
  color: #3b4057 !important; }

._sortable-list-item__context-menu-options_101pd_349 ._dropdown-options_101pd_349 {
  width: unset !important; }

._sortable-list-item-ghost__layer-wrapper_101pd_352 {
  pointer-events: none;
  z-index: 100;
  left: 0;
  top: 0;
  position: fixed; }

._sortable-list-item__ghost-layer_101pd_359 {
  transform: translate3d(calc(var(--xOffset) * 1px), calc(var(--yOffset) * 1px), 0);
  width: calc(var(--itemWidth) * 1px); }

._sortable-list-item-ghost_101pd_352 {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 20px [icon] minmax(0, 1fr) [label];
  align-items: center;
  width: 100%;
  height: 36px;
  padding: 0 6px;
  background: rgba(231, 240, 255, 0.6);
  border-radius: 4px;
  box-shadow: 2px 2px 14px 0 rgba(0, 6, 36, 0.18); }

._sortable-list-item-ghost__icon_101pd_375 {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center; }
  ._sortable-list-item-ghost__icon_101pd_375 * {
    fill: #3b4057 !important;
    color: #3b4057 !important; }

._sortable-list-item-ghost__text_101pd_384 {
  padding-left: 6px;
  max-width: 100%; }

._sortable-list-item_101pd_269 {
  position: relative;
  height: 36px;
  background: #ffffff;
  padding-right: 6px;
  align-items: center;
  box-sizing: border-box; }
  ._sortable-list-item_101pd_269:hover:not(._sortable-list-item_placeholder_101pd_395) {
    background-color: #e7f0ff; }
  ._sortable-list-item_selected_101pd_397 {
    background: #d6e6fe; }
    ._sortable-list-item_selected_101pd_397 ._sortable-list-item__prefix_101pd_399 * {
      fill: #116dff !important;
      color: #116dff !important; }
    ._sortable-list-item_selected_101pd_397 ._sortable-list-item__text_101pd_402 ._control-label_101pd_402 {
      color: #116dff !important; }
  ._sortable-list-item__custom-button-wrapper_101pd_404 {
    display: flex; }
  ._sortable-list-item__context-menu_101pd_335, ._sortable-list-item__custom-button_101pd_404 {
    margin: 6px; }
  ._sortable-list-item_101pd_269:not(:hover) ._sortable-list-item__context-menu_101pd_335 {
    visibility: hidden; }
  ._sortable-list-item_101pd_269:not(:hover) ._sortable-list-item__custom-button_101pd_404 {
    visibility: hidden; }
  ._sortable-list-item_101pd_269:not(:hover) ._sortable-list-item__drag-indicator_101pd_412 {
    visibility: hidden; }

._sortable-list-item__view_101pd_415 {
  cursor: move;
  display: grid;
  grid-template-columns: 6px [drag-indicator] 18px [arrow] calc( 20px + var(--nestingLevel) * 17px) [icon] minmax(0, 1fr) [label] -webkit-min-content [icons] -webkit-min-content [context-menu];
  grid-template-columns: 6px [drag-indicator] 18px [arrow] calc( 20px + var(--nestingLevel) * 17px) [icon] minmax(0, 1fr) [label] min-content [icons] min-content [context-menu];
  grid-template-rows: 36px;
  align-items: center;
  justify-items: end;
  padding-left: 6px;
  width: 100%; }
  ._sortable-list-item__view_101pd_415 ._control-label_101pd_402 {
    cursor: move; }

._sortable-list-item__prefix_101pd_399 {
  position: relative;
  height: 100%;
  justify-self: end;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px; }
  ._sortable-list-item__prefix_101pd_399 * {
    fill: #3b4057 !important;
    color: #3b4057 !important; }

._sortable-list-item__drag-indicator_101pd_412 {
  display: flex; }

._sortable-list-item__text_101pd_402 {
  justify-self: start;
  padding-left: 6px;
  max-width: 100%; }

._sortable-list-item__text_no-symbol_101pd_448 {
  grid-column: arrow / label; }

._sortable-list-item__nesting-line_101pd_451 {
  position: relative;
  align-self: stretch;
  justify-self: stretch;
  left: calc(var(--nestingLevel) * 18px - 18px); }
  ._sortable-list-item__nesting-line_101pd_451::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 8px;
    left: 10px;
    border-left: 1px solid #dfe5eb; }
    ._sortable-list-item_last_101pd_464 ._sortable-list-item__nesting-line_101pd_451::after {
      bottom: 50%;
      border-left: 1px solid #dfe5eb;
      border-bottom: 1px solid #dfe5eb; }
  ._sortable-list-item__nesting-line_101pd_451._sortable-list-item__nesting-line__sub_101pd_468::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 8px;
    left: -16px;
    border-right: 1px solid #dfe5eb; }
    ._sortable-list-item_last-upperlevel_101pd_476 ._sortable-list-item__nesting-line_101pd_451._sortable-list-item__nesting-line__sub_101pd_468::before {
      bottom: 50%;
      border-left: 1px solid #dfe5eb;
      border-bottom: 1px solid #dfe5eb;
      border-right: none;
      left: -8px; }

._sortable-list-item_drop-on_101pd_483 {
  box-shadow: inset 0 0 0 2px #116dff; }

._sortable-list-item_dragging_101pd_486 {
  background-color: #e7f0ff;
  box-shadow: none !important;
  cursor: grabbing !important;
  color: #f00 !important; }
  ._sortable-list-item_dragging_101pd_486 > *:not(._sortable-list-item__nesting-line_101pd_451) {
    opacity: 0; }

._sortable-list-item__arrow_101pd_494:not(._sortable-list-item__nesting-line_101pd_451) {
  width: 16px;
  height: 16px;
  display: none; }

._sortable-list-item_with-arrow_101pd_499 ._sortable-list-item__arrow_101pd_494:not(._sortable-list-item__nesting-line_101pd_451) {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-out; }

._sortable-list-item_with-arrow_101pd_499 ._sortable-list-item__arrow_101pd_494::before {
  content: '';
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 4px solid #868aa5;
  position: absolute;
  top: calc(50% - 4px);
  left: 20px;
  cursor: pointer; }

._sortable-list-item_with-arrow_101pd_499 ._sortable-list-item__arrow_101pd_494._sortable-list-item__nesting-line_101pd_451::before {
  left: 26px; }

._sortable-list-item_with-arrow_101pd_499 ._sortable-list-item__arrow_101pd_494._sortable-list-item__arrow_closed_101pd_521::before {
  transform: rotate(90deg); }

._sortable-list-item_block-drag_101pd_524 ._sortable-list-item__view_101pd_415 ._control-label_101pd_402 {
  cursor: not-allowed; }

._sortable-list-item_block-drag_101pd_524 ._sortable-list-item__view_101pd_415 {
  cursor: not-allowed; }

._sortable-list-item_block-drag_101pd_524 ._sortable-list-item__drag-indicator_101pd_412 {
  visibility: hidden; }

._sortable-list-item_placeholder_101pd_395 ._sortable-list-item__text_101pd_402 ._control-label_101pd_402 {
  color: #acafc4 !important; }

._sortable-list__items-list_101pd_536 {
  background-color: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: stretch;
  width: 100%; }

._sortable-list__dropzone_before_101pd_545,
._sortable-list__dropzone_after_101pd_546 {
  min-height: 12px; }

._sortable-list__dropzone_after_101pd_546 {
  flex-grow: 1; }

._control-button_101pd_552 ._symbol-with-label_101pd_552 {
  margin-right: 8px; }

._button-wrapper-center_101pd_555 {
  text-align: center;
  margin-bottom: 15px; }

._control-button2_101pd_559 {
  margin: 0;
  padding: 0;
  cursor: pointer;
  font-size: 0;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center; }
  ._btn-back_101pd_567._control-button2_101pd_559 {
    min-width: 67px;
    height: 21px;
    background-color: #e7f0ff; }
    ._btn-back_101pd_567._control-button2_101pd_559:hover {
      background-color: #d6e6fe; }
  ._default_101pd_573._control-button2_101pd_559, ._btn-confirm-primary_101pd_573._control-button2_101pd_559 {
    background-color: #116dff;
    color: #fff; }
    ._default_101pd_573._control-button2_101pd_559:hover, ._btn-confirm-primary_101pd_573._control-button2_101pd_559:hover {
      background-color: #5999ff; }
    ._default_101pd_573._control-button2_101pd_559:active, ._btn-confirm-primary_101pd_573._control-button2_101pd_559:active {
      background-color: #116dff; }
  ._btn-confirm-primary_101pd_573._control-button2_101pd_559 {
    color: #fff; }
  ._default_101pd_573._control-button2_101pd_559 {
    height: 36px;
    border-radius: 18px; }
    ._default_101pd_573._control-button2_101pd_559 ._symbol_101pd_552:nth-child(2):nth-last-child(2) {
      margin-left: 8px; }
  ._btn-confirm-secondary_101pd_587._control-button2_101pd_559 {
    background-color: #e7f0ff;
    color: #116dff; }
    ._btn-confirm-secondary_101pd_587._control-button2_101pd_559:hover {
      background-color: #d6e6fe; }
    ._btn-confirm-secondary_101pd_587._control-button2_101pd_559:active {
      background-color: #e7f0ff; }
  ._btn-md_101pd_594._control-button2_101pd_559, ._btn-sm_101pd_594._control-button2_101pd_559 {
    padding: 0 18px;
    border-radius: 15px; }
  ._btn-md_101pd_594._control-button2_101pd_559 {
    height: 30px; }
  ._btn-sm_101pd_594._control-button2_101pd_559 {
    height: 24px; }
  ._btn-text_101pd_601._control-button2_101pd_559 {
    background: 0;
    font-size: 18px;
    color: #116dff; }
  ._btn-danger-secondary_101pd_605._control-button2_101pd_559 {
    background-color: #fde3e1;
    color: #e62214; }
    ._btn-danger-secondary_101pd_605._control-button2_101pd_559:hover {
      background-color: #fbd0cd; }
    ._btn-danger-secondary_101pd_605._control-button2_101pd_559:active {
      background-color: #fde3e1; }
  ._btn-danger-primary_101pd_612._control-button2_101pd_559 {
    background-color: #e62214;
    color: #fff; }
    ._btn-danger-primary_101pd_612._control-button2_101pd_559:hover {
      background-color: #ff6d63; }
    ._btn-danger-primary_101pd_612._control-button2_101pd_559:active {
      background-color: #e62214; }
  ._control-button2_101pd_559[disabled] {
    cursor: default; }
    ._default_101pd_573._control-button2_101pd_559[disabled] {
      background-color: #bcbcbc; }
  ._control-button2_101pd_559 > input {
    display: none; }
  ._control-button2_101pd_559 > ._label_101pd_625,
  ._control-button2_101pd_559 > ._symbol_101pd_552 {
    display: inline-block; }
  ._control-button2_101pd_559 > ._label_101pd_625 {
    font-size: initial; }
    ._btn-back_101pd_567._control-button2_101pd_559 > ._label_101pd_625 {
      color: #116dff;
      font-size: 13px; }
    ._default_101pd_573._control-button2_101pd_559 > ._label_101pd_625 {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-size: 16px;
      padding: 0 24px;
      color: #fff; }
    ._btn-text_101pd_601._control-button2_101pd_559 > ._label_101pd_625 {
      text-decoration: underline; }

._classic-facelift-skin_101pd_644 ._control-button2_101pd_559._default_101pd_573 > ._label_101pd_625 {
  font-family: var(--wbu-font-stack); }

._file-input-control_101pd_647 {
  margin: 0;
  padding: 0;
  cursor: pointer; }
  ._file-input-control_101pd_647._button_101pd_555 {
    box-sizing: border-box;
    height: 30px;
    border-radius: 18px;
    background-color: #fe620f;
    color: #fff;
    margin-left: auto;
    padding-left: 22px; }
    ._file-input-control_101pd_647._button_101pd_555:hover {
      background-color: #ff7d38; }
    ._file-input-control_101pd_647._button_101pd_555:active {
      background-color: #fe620f; }
    ._file-input-control_101pd_647._button_101pd_555[disabled] {
      cursor: default;
      background-color: #bcbcbc; }
    ._file-input-control_101pd_647._button_101pd_555 > ._label_101pd_625,
    ._file-input-control_101pd_647._button_101pd_555 > ._symbol_101pd_552 {
      display: inline-block;
      vertical-align: middle;
      margin-top: 4px; }
    ._file-input-control_101pd_647._button_101pd_555 > ._label_101pd_625 {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      padding: 0 24px 0 11px;
      color: #fff; }
  ._file-input-control_101pd_647._text_101pd_682 > ._label_101pd_625 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    color: #116dff; }
  ._file-input-control_101pd_647 > input {
    display: none; }

._input-date-picker_101pd_692 {
  position: relative;
  background-color: #fff;
  border-radius: 4px; }
  ._input-date-picker_101pd_692 ._dp-header_101pd_696 {
    box-sizing: border-box;
    height: 48px;
    line-height: 32px;
    padding: 8px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    box-shadow: 0 1px 3.96px 0.04px rgba(0, 0, 0, 0.05);
    border-bottom: 1px solid #f7f8f8; }
    ._input-date-picker_101pd_692 ._dp-header_101pd_696 ._dp-previous_101pd_707 {
      transform: rotate(-180deg); }
    ._input-date-picker_101pd_692 ._dp-header_101pd_696 ._dp-navigate_101pd_709 {
      height: 32px;
      width: 32px;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center; }
      ._input-date-picker_101pd_692 ._dp-header_101pd_696 ._dp-navigate_101pd_709:hover {
        background-color: #e7f0ff; }
      ._input-date-picker_101pd_692 ._dp-header_101pd_696 ._dp-navigate_101pd_709:active {
        background-color: #116dff; }
        ._input-date-picker_101pd_692 ._dp-header_101pd_696 ._dp-navigate_101pd_709:active * {
          fill: #fff; }
    ._input-date-picker_101pd_692 ._dp-header_101pd_696 ._dp-title_101pd_723 {
      flex: 1;
      font-family: HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-size: 14px;
      color: #116dff; }
  ._input-date-picker_101pd_692 ._dp-body_101pd_728 table {
    text-align: center;
    width: calc(100% - 24px);
    margin: 8px 12px;
    font-size: 13px;
    font-family: HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    color: #3b4057; }
    ._input-date-picker_101pd_692 ._dp-body_101pd_728 table td div {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      line-height: 32px; }
    ._input-date-picker_101pd_692 ._dp-body_101pd_728 table ._dp-day-name_101pd_740 {
      font-weight: bold; }
  ._input-date-picker_101pd_692 ._dp-day_101pd_740 {
    cursor: pointer; }
    ._input-date-picker_101pd_692 ._dp-day_101pd_740:not(._dp-day-selected_101pd_744):hover {
      background-color: #e7f0ff; }
  ._input-date-picker_101pd_692 ._dp-day-not-in-current-month_101pd_746 {
    color: #dfe5eb; }
  ._input-date-picker_101pd_692 ._dp-day-selected_101pd_744,
  ._input-date-picker_101pd_692 ._dp-day-selected_101pd_744:hover {
    background-color: #116dff;
    color: #fff; }
  ._input-date-picker_101pd_692 ._dp-today_101pd_752:not(._dp-day-not-in-current-month_101pd_746) {
    border: 1px solid #116dff; }
  ._input-date-picker_101pd_692 ._dp-footer_101pd_754 {
    border-top: 1px solid #f7f8f8;
    height: 32px;
    padding: 12px; }
    ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._delete-btn_101pd_758 {
      background-color: #fff;
      padding: 0 12px;
      margin-right: 12px;
      height: 32px;
      vertical-align: middle; }
      ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._delete-btn_101pd_758 path {
        fill: #3b4057; }
      ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._delete-btn_101pd_758:hover path {
        fill: #e62214; }
    ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._goto-today_101pd_768,
    ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._goto-selection_101pd_769 {
      font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      background-color: transparent;
      color: #116dff;
      display: inline-block;
      border-radius: 32px;
      line-height: 32px;
      height: 32px;
      padding: 0 20px;
      cursor: pointer; }
      ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._goto-today_101pd_768:hover,
      ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._goto-selection_101pd_769:hover {
        background-color: #e7f0ff; }
    ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._goto-selection_101pd_769 {
      float: right; }
      ._input-date-picker_101pd_692 ._dp-footer_101pd_754 ._goto-selection_101pd_769:disabled {
        cursor: inherit;
        color: #bcbcbc;
        background-color: transparent; }

._control-angle_101pd_793 {
  position: relative;
  height: 108px; }
  ._control-angle_101pd_793 > ._disabled_101pd_796 {
    opacity: 0.4; }
  ._control-angle_101pd_793 > ._circle_101pd_798 {
    width: 72px;
    height: 72px;
    top: 32px;
    left: 48px;
    border-radius: 50%;
    border: solid 4px #d6e1e8;
    position: absolute;
    box-sizing: border-box; }
    ._control-angle_101pd_793 > ._circle_101pd_798:hover > ._knob_101pd_807 {
      background-color: #86ccf7; }
    ._control-angle_101pd_793 > ._circle_101pd_798:active > ._circle-center_101pd_809,
    ._control-angle_101pd_793 > ._circle_101pd_798:active > ._knob_101pd_807 {
      background-color: #0199ef; }
    ._control-angle_101pd_793 > ._circle_101pd_798:active:after {
      border: solid 1px #0199ef; }
    ._control-angle_101pd_793 > ._circle_101pd_798:hover > ._knob_101pd_807, ._control-angle_101pd_793 > ._circle_101pd_798:active > ._knob_101pd_807 {
      box-shadow: 0 0 4px 1px rgba(25, 94, 153, 0.3), 0 0 8px 1px #86ccf7; }
    ._control-angle_101pd_793 > ._circle_101pd_798 > ._circle-center_101pd_809 {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      position: absolute;
      background-color: #d6e1e8;
      top: calc(50% - 3px);
      left: calc(50% - 3px); }
    ._control-angle_101pd_793 > ._circle_101pd_798:after {
      width: 0;
      height: 32px;
      content: '';
      position: absolute;
      border: solid 1px #d6e1e8;
      z-index: -1;
      left: 31px; }
    ._control-angle_101pd_793 > ._circle_101pd_798 ._knob_101pd_807 {
      width: 8px;
      height: 8px;
      position: absolute;
      cursor: pointer;
      background-color: #116dff;
      border-radius: 50%;
      border: solid 4px #fff;
      box-shadow: 0 0 4px 1px rgba(25, 94, 153, 0.3);
      box-sizing: border-box;
      top: -5px;
      left: calc(50% - 4px); }
  ._control-angle_101pd_793 > ._control-label_101pd_402 {
    width: 54px;
    color: #3b4057;
    font-size: 14px;
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif; }
  ._animation-panel_101pd_849 ._control-angle_101pd_793 {
    margin: 17px 10px 7px 24px;
    height: 96px; }
    ._animation-panel_101pd_849 ._control-angle_101pd_793 ._input-stepper_101pd_852 {
      left: auto;
      top: 28px;
      right: 0;
      width: 56px;
      padding: 0 6px; }
    ._animation-panel_101pd_849 ._control-angle_101pd_793 ._circle_101pd_798 {
      top: 18px;
      left: 80px; }

._control-thumbnails_101pd_862 {
  position: relative;
  padding: 13px 24px 16px;
  white-space: initial; }
  ._control-thumbnails_101pd_862,
  ._control-thumbnails_101pd_862 * {
    box-sizing: border-box;
    font-size: 0; }
  ._control-thumbnails_101pd_862 ._radio-control_101pd_870 {
    position: relative;
    display: inline-block;
    margin: 0 12px 12px 0;
    vertical-align: top; }
    ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._svg-radio_101pd_875 {
      position: relative;
      width: 100%;
      background-color: #e7f0ff;
      display: inline-block;
      border-radius: 4px;
      transition: background-color 0.2s; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._svg-radio_101pd_875:hover {
        background-color: #d6e6fe; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._svg-radio_101pd_875._disabled_101pd_796 {
        background-color: #f0f0f0; }
    ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._image-radio_101pd_886 {
      position: relative;
      overflow: hidden;
      width: 100%;
      border: 1px solid #dfe5eb;
      display: inline-block;
      border-radius: 4px; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._image-radio_101pd_886 ._image-radio-src_101pd_893 {
        position: relative;
        display: block;
        top: -1px;
        left: -1px; }
    ._control-thumbnails_101pd_862 ._radio-control_101pd_870:hover ._image-radio_101pd_886 {
      border: 2px solid #80b1ff; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870:hover ._image-radio_101pd_886 ._image-radio-src_101pd_893 {
        top: -2px;
        left: -2px; }
    ._control-thumbnails_101pd_862 ._radio-control_101pd_870 input:checked + ._svg-radio_101pd_875 {
      background-color: #116dff; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870 input:checked + ._svg-radio_101pd_875._symbol-thumb-none_101pd_905, ._control-thumbnails_101pd_862 ._radio-control_101pd_870 input:checked + ._svg-radio_101pd_875._symbol-transition-none_101pd_905 {
        background-color: #e7f0ff; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870 input:checked + ._svg-radio_101pd_875 ._cls-5_101pd_907._cls-5_101pd_907 {
        fill: #e7f0ff; }
    ._control-thumbnails_101pd_862 ._radio-control_101pd_870 input:checked + ._image-radio_101pd_886 {
      border: 2px solid #116dff; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870 input:checked + ._image-radio_101pd_886 ._image-radio-src_101pd_893 {
        top: -2px;
        left: -2px; }
    ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._label_101pd_625 {
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 12px;
      -webkit-font-smoothing: antialiased;
      display: block;
      text-align: center;
      color: #116dff;
      padding-top: 9px; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._label_101pd_625._disabled_101pd_796 {
        color: #bcbcbc; }
    ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._notify-symbol_101pd_926 {
      position: absolute; }
      ._control-thumbnails_101pd_862 ._radio-control_101pd_870 ._notify-symbol_101pd_926._notify-symbol-small-right_101pd_928 {
        right: -8px;
        top: -8px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='0'] ._radio-control_101pd_870 {
    width: 114px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='0'] ._radio-control_101pd_870:nth-of-type(2n) {
      margin-right: 0px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='0'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='0'] input + ._image-radio_101pd_886 {
    height: 114px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='0']._with-title_101pd_937 span:last-of-type {
    max-width: 114px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='1'] ._radio-control_101pd_870 {
    width: 114px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='1'] ._radio-control_101pd_870:nth-of-type(1n) {
      margin-right: 126px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='1'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='1'] input + ._image-radio_101pd_886 {
    height: 114px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='1']._with-title_101pd_937 span:last-of-type {
    max-width: 114px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='2'] ._radio-control_101pd_870 {
    width: 114px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='2'] ._radio-control_101pd_870:nth-of-type(0n) {
      margin-right: 252px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='2'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='2'] input + ._image-radio_101pd_886 {
    height: 114px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='2'][data-items-to-skip='2']._with-title_101pd_937 span:last-of-type {
    max-width: 114px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='0'] ._radio-control_101pd_870 {
    width: 72px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='0'] ._radio-control_101pd_870:nth-of-type(3n) {
      margin-right: 0px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='0'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='0'] input + ._image-radio_101pd_886 {
    height: 72px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='0']._with-title_101pd_937 span:last-of-type {
    max-width: 72px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='1'] ._radio-control_101pd_870 {
    width: 72px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='1'] ._radio-control_101pd_870:nth-of-type(2n) {
      margin-right: 84px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='1'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='1'] input + ._image-radio_101pd_886 {
    height: 72px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='1']._with-title_101pd_937 span:last-of-type {
    max-width: 72px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='2'] ._radio-control_101pd_870 {
    width: 72px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='2'] ._radio-control_101pd_870:nth-of-type(1n) {
      margin-right: 168px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='2'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='2'] input + ._image-radio_101pd_886 {
    height: 72px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='3'][data-items-to-skip='2']._with-title_101pd_937 span:last-of-type {
    max-width: 72px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='0'] ._radio-control_101pd_870 {
    width: 51px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='0'] ._radio-control_101pd_870:nth-of-type(4n) {
      margin-right: 0px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='0'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='0'] input + ._image-radio_101pd_886 {
    height: 51px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='0']._with-title_101pd_937 span:last-of-type {
    max-width: 51px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='1'] ._radio-control_101pd_870 {
    width: 51px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='1'] ._radio-control_101pd_870:nth-of-type(3n) {
      margin-right: 63px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='1'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='1'] input + ._image-radio_101pd_886 {
    height: 51px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='1']._with-title_101pd_937 span:last-of-type {
    max-width: 51px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='2'] ._radio-control_101pd_870 {
    width: 51px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='2'] ._radio-control_101pd_870:nth-of-type(2n) {
      margin-right: 126px; }
  ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='2'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='2'] input + ._image-radio_101pd_886 {
    height: 51px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='4'][data-items-to-skip='2']._with-title_101pd_937 span:last-of-type {
    max-width: 51px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='0'] ._radio-control_101pd_870 {
    width: 38.4px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='0'] ._radio-control_101pd_870:nth-of-type(5n) {
      margin-right: 0px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='0'] input + ._svg-radio_101pd_875,
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='0'] input + ._image-radio_101pd_886 {
    border-radius: 6px; }
    ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='0'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='0'] input + ._image-radio_101pd_886 {
      height: 38.4px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='0']._with-title_101pd_937 span:last-of-type {
    max-width: 38.4px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='1'] ._radio-control_101pd_870 {
    width: 38.4px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='1'] ._radio-control_101pd_870:nth-of-type(4n) {
      margin-right: 50.4px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='1'] input + ._svg-radio_101pd_875,
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='1'] input + ._image-radio_101pd_886 {
    border-radius: 6px; }
    ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='1'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='1'] input + ._image-radio_101pd_886 {
      height: 38.4px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='1']._with-title_101pd_937 span:last-of-type {
    max-width: 38.4px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='2'] ._radio-control_101pd_870 {
    width: 38.4px; }
    ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='2'] ._radio-control_101pd_870:nth-of-type(3n) {
      margin-right: 100.8px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='2'] input + ._svg-radio_101pd_875,
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='2'] input + ._image-radio_101pd_886 {
    border-radius: 6px; }
    ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='2'] input + ._svg-radio_101pd_875, ._square_101pd_935._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='2'] input + ._image-radio_101pd_886 {
      height: 38.4px; }
  ._control-thumbnails_101pd_862[data-max-thumbs-per-row='5'][data-items-to-skip='2']._with-title_101pd_937 span:last-of-type {
    max-width: 38.4px; }
  ._control-thumbnails_101pd_862._with-title_101pd_937 > div {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    display: block;
    color: #3b4057;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 15px; }
  ._control-thumbnails_101pd_862 ._info-icon_101pd_1047 {
    position: absolute;
    right: 12px;
    top: 12px;
    opacity: 0;
    transition-property: opacity;
    transition-duration: 0.15s; }
  ._control-thumbnails_101pd_862:hover ._info-icon_101pd_1047 {
    opacity: 1; }

._thumbnails-with-icons_101pd_1057 ._control-header_101pd_1057 {
  display: flex; }
  ._thumbnails-with-icons_101pd_1057 ._control-header_101pd_1057 ._thumbnails-with-icons-label_101pd_1059 {
    flex: 1; }
  ._thumbnails-with-icons_101pd_1057 ._control-header_101pd_1057 ._info-icon_101pd_1047 {
    opacity: 0;
    float: right;
    position: relative;
    transition-property: opacity;
    transition-duration: 0.15s; }

._thumbnails-with-icons_101pd_1057:hover ._control-header_101pd_1057 ._info-icon_101pd_1047 {
  opacity: 1; }

._thumbnails-with-icons_101pd_1057 ._thumbnails-with-icons-label_101pd_1059,
._thumbnails-with-icons_101pd_1057 ._option-title_101pd_1072 {
  font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--wbu-font-weight-regular);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  color: #3b4057;
  text-overflow: ellipsis;
  overflow: hidden; }

._thumbnails-with-icons_101pd_1057 ._thumbnails-with-icons-label_101pd_1059 {
  margin-bottom: 12px; }

._thumbnails-with-icons_101pd_1057 label {
  display: inline-block;
  cursor: pointer;
  text-align: center; }
  ._thumbnails-with-icons_101pd_1057 label:first-of-type {
    margin-right: 12px; }
  ._thumbnails-with-icons_101pd_1057 label svg {
    max-width: 62px;
    max-height: 62px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%); }

._thumbnails-with-icons_101pd_1057 input {
  display: none; }
  ._thumbnails-with-icons_101pd_1057 input + span {
    padding-bottom: 18px;
    display: inline-block;
    border-radius: 4px;
    width: 114px;
    box-shadow: inset 0 0 0 1px #dfe5eb;
    font-size: 0;
    box-sizing: border-box;
    text-overflow: ellipsis;
    overflow: hidden; }
  ._thumbnails-with-icons_101pd_1057 input:checked + span {
    box-shadow: inset 0 0 0 2px #116dff; }
    ._thumbnails-with-icons_101pd_1057 input:checked + span ._option-title_101pd_1072 {
      color: #116dff; }
  ._thumbnails-with-icons_101pd_1057 input:not(:checked) + span:hover {
    box-shadow: inset 0 0 0 2px #d6e6fe; }

._thumbnails-with-icons_101pd_1057 ._image-container_101pd_1118 {
  display: block;
  width: 78px;
  height: 83px;
  border-bottom: 1px solid #dfe5eb;
  margin: 0 auto 12px auto;
  position: relative;
  box-sizing: border-box; }

._thumbnails-vertical_101pd_1127 {
  width: 100%;
  text-align: center;
  margin: 24px 0; }
  ._thumbnails-vertical_101pd_1127 label {
    display: block;
    margin: 12px 0;
    line-height: 0; }
  ._thumbnails-vertical_101pd_1127 ._thumbnail-container_101pd_1135 {
    cursor: pointer;
    box-shadow: 0 0 0 1px #dfe5eb inset;
    border-radius: 6px;
    display: inline-block;
    width: calc(100% - 48px);
    line-height: 0;
    overflow: hidden; }
    ._thumbnails-vertical_101pd_1127 ._thumbnail-container_101pd_1135 img {
      margin: 20px 24px 13px 25px; }
      ._thumbnails-vertical_101pd_1127 ._thumbnail-container_101pd_1135 img._withoutLabel_101pd_1145 {
        margin-bottom: 20px; }
    ._thumbnails-vertical_101pd_1127 ._thumbnail-container_101pd_1135 span {
      margin: 0 0 12px 0;
      line-height: 14px; }
    ._thumbnails-vertical_101pd_1127 ._thumbnail-container_101pd_1135._right_101pd_1150 {
      text-align: right; }
    ._thumbnails-vertical_101pd_1127 ._thumbnail-container_101pd_1135._left_101pd_1152 {
      text-align: left; }
  ._thumbnails-vertical_101pd_1127 ._thumbnail-title_101pd_1154 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    margin: 0;
    display: inline-block;
    color: #3b4057; }
  ._thumbnails-vertical_101pd_1127 input {
    display: none; }
    ._thumbnails-vertical_101pd_1127 input:checked + ._thumbnail-container_101pd_1135 {
      box-shadow: 0 0 0 2px #116dff inset; }
      ._thumbnails-vertical_101pd_1127 input:checked + ._thumbnail-container_101pd_1135 ._thumbnail-title_101pd_1154 {
        color: #116dff; }
    ._thumbnails-vertical_101pd_1127 input:not(:checked) + ._thumbnail-container_101pd_1135:hover {
      box-shadow: 0 0 0 2px #d6e6fe inset; }

._control-mandatory_101pd_1172 {
  position: relative;
  cursor: pointer; }
  ._control-mandatory_101pd_1172:after {
    content: attr(data-text);
    display: inline-block;
    margin-left: 13px;
    position: absolute;
    white-space: nowrap;
    line-height: 18px; }
  ._control-mandatory_101pd_1172 input {
    display: none; }
    ._control-mandatory_101pd_1172 input + span {
      width: 16px;
      height: 16px;
      border: solid 1px #116dff;
      display: inline-block;
      border-radius: 50%;
      transition-property: background-color, color;
      transition-duration: 0.2s;
      position: relative;
      background-color: #f7f8f8; }
      ._control-mandatory_101pd_1172 input + span:before {
        content: '*';
        color: #b6c1cd;
        font-size: 30px;
        position: absolute;
        top: 4.5px;
        left: 2.7px;
        line-height: 18px; }
    ._control-mandatory_101pd_1172 input:checked + span {
      background-color: #f7f8f8; }
      ._control-mandatory_101pd_1172 input:checked + span:before {
        color: #116dff; }
    ._control-mandatory_101pd_1172 input:disabled + span {
      border-color: #bcbcbc; }
      ._control-mandatory_101pd_1172 input:disabled + span:before {
        color: #bcbcbc; }
  ._control-mandatory_101pd_1172:hover input + span {
    background-color: #fff; }
    ._control-mandatory_101pd_1172:hover input + span:before {
      color: #b6c1cd; }
  ._control-mandatory_101pd_1172:hover input:checked + span {
    background-color: #e7f0ff; }
    ._control-mandatory_101pd_1172:hover input:checked + span:before {
      color: #116dff; }
  ._control-mandatory_101pd_1172:hover input:disabled + span {
    border-color: #bcbcbc;
    background-color: #f7f8f8; }
    ._control-mandatory_101pd_1172:hover input:disabled + span:before {
      color: #bcbcbc; }

._control-buttons-group_101pd_1224 {
  font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--wbu-font-weight-regular);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  white-space: nowrap;
  color: #3b4057;
  position: relative; }
  ._control-buttons-group_101pd_1224 p {
    font-size: 14px;
    color: #3b4057;
    font-weight: 300;
    margin-bottom: 15px;
    margin-top: 0; }
  ._control-buttons-group_101pd_1224 ._group-buttons-container-left_101pd_1239 {
    text-align: left; }
  ._control-buttons-group_101pd_1224 ._group-buttons-container-right_101pd_1241 {
    text-align: right; }
  ._control-buttons-group_101pd_1224 ._group-buttons-container-center_101pd_1243 {
    text-align: center; }
  ._control-buttons-group_101pd_1224 ._info-icon_101pd_1047 {
    display: none;
    position: absolute;
    top: 0;
    right: 0; }
  ._control-buttons-group_101pd_1224:hover ._info-icon_101pd_1047 {
    display: inline-block; }
  ._control-buttons-group_101pd_1224 input {
    display: none; }
    ._control-buttons-group_101pd_1224 input + span {
      color: #116dff;
      cursor: pointer;
      height: 36px;
      background-color: #edf7ff;
      display: inline-block;
      position: relative;
      white-space: nowrap;
      line-height: 36px;
      vertical-align: middle;
      font-size: 14px;
      padding: 0 14px;
      max-width: 93px;
      min-width: 74px;
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
      box-shadow: 0 2px 0 0 #d4e7fb; }
    ._control-buttons-group_101pd_1224 input:checked + span {
      color: #fff;
      position: relative;
      top: 2px;
      background-color: #116dff;
      box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.11); }
    ._control-buttons-group_101pd_1224 input:disabled + span {
      cursor: default;
      background-color: #f6f6f6; }
    ._control-buttons-group_101pd_1224 input:disabled:checked + span {
      background-color: #bcbcbc; }
    ._control-buttons-group_101pd_1224 input:disabled:not(:checked) + span {
      color: #bcbcbc;
      box-shadow: 0 2px 0 0 #e5e5e5; }
  ._control-buttons-group_101pd_1224 label {
    display: inline-block; }
    ._control-buttons-group_101pd_1224 label input + span:hover {
      background-color: #d6e6fe; }
    ._control-buttons-group_101pd_1224 label:first-of-type span {
      border-radius: 20px 0 0 20px; }
    ._control-buttons-group_101pd_1224 label:last-of-type span {
      border-radius: 0 20px 20px 0; }
  ._animation-panel_101pd_849 ._control-buttons-group_101pd_1224 {
    text-align: center; }

._control-tabs-horizontal_101pd_1297 {
  box-sizing: border-box;
  font-size: 0;
  width: 100%; }
  ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 {
    height: 59px;
    background-color: #fff; }
  ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.05); }
  ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 {
    margin: 18px 0;
    width: 240px;
    counter-reset: boxes 0; }
  ._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 {
    text-align: center;
    cursor: pointer;
    display: inline-block;
    box-sizing: border-box; }
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(1),
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(1) ~ label, ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(1),
    ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(1) ~ label {
      width: 100%; }
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(2),
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(2) ~ label, ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(2),
    ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(2) ~ label {
      width: 50%; }
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(3),
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(3) ~ label, ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(3),
    ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(3) ~ label {
      width: 33.33333%; }
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(4),
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(4) ~ label, ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(4),
    ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(4) ~ label {
      width: 25%; }
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(5),
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(5) ~ label, ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(5),
    ._horizontal_101pd_1316._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(5) ~ label {
      width: 20%; }
    ._vertical_101pd_1335._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 {
      display: block; }
    ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 {
      vertical-align: middle; }
    ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 {
      height: 52px; }
      ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(1),
      ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(1) ~ label {
        width: 100%; }
      ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(2),
      ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(2) ~ label {
        width: 50%; }
      ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(3),
      ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(3) ~ label {
        width: 33.33333%; }
      ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(4),
      ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child:nth-last-child(4) ~ label {
        width: 25%; }
    ._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 {
      display: none; }
      ._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
        font-size: 14px;
        box-sizing: border-box;
        transition-duration: 0.2s;
        position: relative; }
        ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
          height: 47px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding: 0 10px;
          background-color: #e7f0ff;
          border-right: solid 1px #d6e6fe;
          transition-property: background-color, border-color; }
          ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309:checked + ._tab-decorator_101pd_1355 {
            background-color: #fff;
            border-color: transparent; }
          ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:last-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
            border-right: none; }
        ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355, ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
          color: #3b4057; }
        ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355, ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
          display: block; }
        ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
          transition-property: border-color; }
          ._horizontal_101pd_1316._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
            border-bottom: solid 3px #116dff;
            padding-right: 3px;
            padding-left: 3px;
            height: 84px; }
          ._vertical_101pd_1335._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
            border-right: solid 3px #116dff;
            padding-right: 12px;
            height: calc( 42px + 3px * 2);
            width: calc( 132px + 12px + 3px); }
            ._vertical_101pd_1335._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:last-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
              height: 42px; }
        ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
          height: 52px;
          padding: 0 6px;
          border-bottom: solid 3px transparent;
          transition-property: border-color; }
          ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:hover > ._input_101pd_309 + ._tab-decorator_101pd_1355 {
            border-bottom-color: #80b1ff; }
          ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309:checked + ._tab-decorator_101pd_1355 {
            border-bottom-color: #116dff;
            color: #3b4057; }
        ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355:hover {
          background-color: #d6e6fe; }
        ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355:after, ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355:after {
          content: '';
          width: 0;
          height: 0;
          border: solid;
          border-color: transparent transparent #116dff;
          border-width: 0 9px 7px;
          position: absolute;
          bottom: -3px;
          left: calc(50% - 9px);
          opacity: 0;
          transition-property: opacity;
          transition-duration: 0.2s; }
          ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309:checked + ._tab-decorator_101pd_1355:after, ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309:checked + ._tab-decorator_101pd_1355:after {
            opacity: 1; }
        ._vertical_101pd_1335._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355:after {
          border-color: transparent transparent transparent #116dff;
          border-width: 9px 0 9px 7px;
          left: calc( 132px + 12px);
          bottom: calc(50% - 3px * 2); }
          ._vertical_101pd_1335._control-tabs-horizontal_101pd_1297:last-child > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355:after {
            bottom: calc(50% - 9px); }
        ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
          display: inline-flex;
          align-items: center;
          height: 49px;
          white-space: normal;
          text-overflow: ellipsis;
          overflow: hidden;
          color: #116dff;
          transition-property: color;
          transition-duration: 0.2s; }
          ._arrowed_101pd_1304._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:hover > ._input_101pd_309:not(:checked) + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
            color: #3b4057; }
        ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
          background-color: #e7f0ff;
          display: inline-block;
          width: 100%;
          vertical-align: middle;
          text-align: center;
          transition-property: background-color;
          transition-duration: 0.2s; }
          ._horizontal_101pd_1316._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
            height: 48px; }
          ._vertical_101pd_1335._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
            height: 42px; }
          ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
            border-top-left-radius: 6px; }
            ._horizontal_101pd_1316._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
              border-bottom-left-radius: 6px; }
            ._vertical_101pd_1335._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:first-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
              border-top-right-radius: 6px; }
          ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:last-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
            border-bottom-right-radius: 6px; }
            ._horizontal_101pd_1316._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:last-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
              border-top-right-radius: 6px; }
            ._vertical_101pd_1335._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:last-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
              border-bottom-left-radius: 6px; }
          ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309:checked + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
            background-color: #116dff; }
          ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:hover > ._input_101pd_309:not(:checked) + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
            background-color: #d6e6fe; }
        ._tabbed_101pd_1301._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310:last-child > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426 {
          border-right: none; }
        ._arrowed-box_101pd_1306._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426:after {
          content: counter(boxes, decimal);
          counter-increment: boxes 1;
          position: absolute;
          bottom: 15px;
          font-size: 12px;
          color: #116dff;
          text-align: center;
          left: calc(50% - 3px); }
        ._vertical_101pd_1335._control-tabs-horizontal_101pd_1297 > ._container_101pd_1310 > ._input_101pd_309 + ._tab-decorator_101pd_1355 > ._text-label_101pd_1426:after {
          left: calc( 132px + 12px + 3px + 7px + 7px);
          bottom: calc(50% - 3px * 2); }

._control-tabs-vertical_101pd_1481 {
  display: block;
  font-size: 0;
  width: 48px;
  height: 100%;
  background-color: #e7f0ff;
  box-shadow: inset -1px 0 0 0 #e5f4ff, inset -2px 0 0 0 #d6e6fe; }
  ._control-tabs-vertical_101pd_1481 ._tab-text_101pd_1488 {
    display: none; }
  ._control-tabs-vertical_101pd_1481._closed_101pd_1490 {
    width: 288px;
    background-color: transparent;
    box-shadow: none; }
    ._control-tabs-vertical_101pd_1481._closed_101pd_1490 svg {
      left: 17px; }
    ._control-tabs-vertical_101pd_1481._closed_101pd_1490 ._tab-text_101pd_1488 {
      display: inline-block; }
  ._control-tabs-vertical_101pd_1481 label {
    cursor: pointer;
    display: block; }
  ._control-tabs-vertical_101pd_1481 input {
    display: none; }
    ._control-tabs-vertical_101pd_1481 input + span {
      display: inline-block;
      width: 100%;
      height: 48px;
      position: relative;
      line-height: 48px; }
      ._control-tabs-vertical_101pd_1481 input + span svg {
        background-repeat: no-repeat;
        width: 15px;
        height: 15px;
        position: absolute;
        top: calc(50% - 7px);
        left: calc(50% - 7px);
        fill: #116dff; }
    ._control-tabs-vertical_101pd_1481 input:checked + span {
      background-color: #ffffff;
      border-top: 1px solid #d6e6fe;
      border-bottom: 1px solid #d6e6fe; }
      ._control-tabs-vertical_101pd_1481 input:checked + span svg {
        fill: #000624; }
    ._control-tabs-vertical_101pd_1481 input:not(:checked) + span {
      box-shadow: inset -1px 0 0 0 #e5f4ff, inset -2px 0 0 0 #d6e6fe; }
      ._control-tabs-vertical_101pd_1481 input:not(:checked) + span:hover {
        background-color: #d6e6fe; }
  ._control-tabs-vertical_101pd_1481 label:first-child input:checked + span {
    border-top: none;
    border-bottom: 1px solid #d6e6fe; }
  ._control-tabs-vertical_101pd_1481 label:last-child input:checked + span {
    border-bottom: none; }

._control-link_101pd_1533 div {
  width: 29px;
  height: 26px;
  border-radius: 6px;
  background-color: transparent;
  border: solid 1px #d6e1e8;
  display: block;
  box-sizing: border-box;
  text-align: center;
  transition-duration: 0.2s;
  transition-property: background-color, border-color; }

._control-link_101pd_1533:not(._disabled_101pd_796) div {
  cursor: pointer; }
  ._control-link_101pd_1533:not(._disabled_101pd_796) div:hover {
    background-color: #d6e6fe;
    border-color: #d6e6fe; }

._control-link_101pd_1533 path {
  fill: #868aa5;
  transition-duration: 0.2s;
  transition-property: fill; }

._control-link_101pd_1533 input {
  display: none; }
  ._control-link_101pd_1533 input:checked + div {
    background-color: #116dff;
    border-color: transparent; }
    ._control-link_101pd_1533 input:checked + div path {
      fill: #fff; }
    ._control-link_101pd_1533 input:checked + div:hover {
      background-color: #5999ff; }

._info-icon_101pd_1047 {
  cursor: pointer;
  border-radius: 50%;
  display: inline-block;
  width: 18px;
  fill: #868aa5; }
  ._label-info-icon-container_101pd_1572._info-icon_101pd_1047 {
    background-color: #3b4057;
    cursor: pointer;
    border-radius: 0;
    width: 30px;
    height: 16px;
    padding-top: 2px;
    box-sizing: border-box; }
  ._accordion-header_101pd_1580 ._info-icon_101pd_1047 {
    position: absolute;
    top: 12px;
    right: 12px;
    display: none; }
    ._accordion-header_101pd_1580:hover ._info-icon_101pd_1047 {
      display: inline-block; }
  ._dropdown_101pd_349 ._info-icon_101pd_1047 {
    vertical-align: middle;
    margin-bottom: 3px;
    line-height: 0;
    opacity: 0;
    transition-property: opacity;
    transition-duration: 0.15s; }
    ._dropdown_101pd_349 ._info-icon_101pd_1047,
    ._dropdown_101pd_349 ._info-icon_101pd_1047 > ._symbol_101pd_552 {
      margin: 0;
      padding: 0; }
  ._dropdown_101pd_349:hover ._info-icon_101pd_1047 {
    opacity: 1; }
  ._control-checkbox_101pd_1600 ._info-icon_101pd_1047 {
    display: none;
    position: absolute;
    top: 0;
    right: 0; }
    ._control-checkbox_101pd_1600:hover ._info-icon_101pd_1047 {
      display: inline-block; }
  ._control-text-input_101pd_1607 ._info-icon_101pd_1047 {
    display: none;
    position: absolute;
    top: 0;
    right: 0; }
    ._control-text-input_101pd_1607:hover ._info-icon_101pd_1047 {
      display: inline-block; }
  ._control-text-input_101pd_1607._always-show-info-icon_101pd_1614 ._info-icon_101pd_1047 {
    display: inline-block;
    position: absolute;
    top: 0;
    right: 0; }
  ._preset-item_101pd_1619 ._info-icon_101pd_1047 {
    position: absolute;
    bottom: 21px;
    right: 16px; }
    ._preset-item_101pd_1619:hover ._info-icon_101pd_1047 {
      opacity: 1; }
      ._preset-item_101pd_1619:hover ._info-icon_101pd_1047:hover {
        color: #fff; }
    ._preset-item_101pd_1619 ._info-icon_101pd_1047 svg circle {
      fill: #fff; }
  ._preset-item_101pd_1619 ._info-wrapper_101pd_1629._has-label_101pd_1629 ._info-icon_101pd_1047 {
    bottom: 26px; }
  ._section-header_101pd_1631 > ._title-line_101pd_1631 ._info-icon_101pd_1047 {
    position: absolute;
    bottom: 6px;
    right: 1px;
    display: none; }
  ._site-members-settings_101pd_1636 ._info-icon_101pd_1047 {
    display: none; }
    ._site-members-settings_101pd_1636:hover ._info-icon_101pd_1047 {
      display: inline-block; }
  ._control-section-divider_101pd_1640._labeled_101pd_1640 ._info-icon_101pd_1047 {
    position: absolute;
    right: 12px;
    top: 12px;
    line-height: 0;
    opacity: 0;
    transition-property: opacity;
    transition-duration: 0.15s; }
  ._control-section-divider_101pd_1640._labeled_101pd_1640:hover ._info-icon_101pd_1047 {
    opacity: 1; }

._control-alignment_101pd_1651 {
  text-align: center; }
  ._control-alignment_101pd_1651 ._cls-4_101pd_1653 {
    fill: #116dff; }
  ._control-alignment_101pd_1651 ._cls-5_101pd_907 {
    fill: #fff; }
  ._control-alignment_101pd_1651 ._label-info-wrapper_101pd_1657 {
    padding-bottom: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center; }
  ._control-alignment_101pd_1651 div._label_101pd_625 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    color: #3b4057;
    font-weight: 300;
    text-align: left; }
  ._control-alignment_101pd_1651 div._items_101pd_1671 {
    display: inline-block;
    width: 90px;
    height: 90px; }
    ._control-alignment_101pd_1651 div._items_101pd_1671 input[type='radio'] {
      display: none; }
    ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 {
      cursor: pointer;
      width: 24px;
      height: 24px;
      margin: 3px;
      float: left; }
      ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 span {
        display: inline-block;
        width: 100%;
        height: 100%;
        border-radius: 6px;
        background: #d6e6fe no-repeat center; }
        ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 span:hover {
          background-color: #80b1ff; }
          ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 span:hover svg {
            visibility: visible; }
        ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 span svg {
          visibility: hidden;
          shape-rendering: crispEdges; }
      ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 input[type='radio']:checked + span {
        background-color: #116dff; }
        ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 input[type='radio']:checked + span svg {
          visibility: visible; }
      ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 input[type='radio']:disabled + span {
        background-color: #f0f0f0; }
      ._control-alignment_101pd_1651 div._items_101pd_1671 label._item_101pd_1671 input[type='radio']:disabled:not(:checked) + span:hover svg {
        visibility: hidden; }

._playIcon_101pd_1705 {
  width: 0;
  height: 0;
  margin-top: 50%;
  margin-left: 50%;
  top: -4px;
  left: -2px;
  position: relative;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 6px solid #116dff; }

._playButton_101pd_1717 {
  width: 22px;
  height: 22px;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
  background-color: #ffffff;
  border: 1px solid #116dff; }
  ._playButton_101pd_1717:hover {
    background-color: #edf7ff; }
  ._playButton_101pd_1717._isPlaying_101pd_1727 {
    background-color: #116dff; }
    ._playButton_101pd_1717._isPlaying_101pd_1727 ._playIcon_101pd_1705 {
      border-left-color: #ffffff; }

._thumbnail-preview-play_101pd_1732 {
  position: relative; }
  ._thumbnail-preview-play_101pd_1732 svg {
    position: absolute;
    left: 18px;
    width: 49px;
    height: 24px;
    top: 50%;
    margin-top: -11px;
    text-align: center; }
  ._thumbnail-preview-play_101pd_1732 ._label_101pd_625 {
    margin-left: 78px;
    margin-right: 48px;
    padding: 0;
    position: relative;
    color: #395671;
    font-size: 14px;
    font-weight: 300; }
  ._thumbnail-preview-play_101pd_1732 ._playButton_101pd_1717 {
    position: absolute;
    right: 18px;
    top: 50%;
    margin-top: -11px; }

._pick-text-alignment_101pd_1756 ._svg-radio_101pd_875 {
  border-radius: 6px;
  background-color: #eaf7fe;
  width: 38px;
  height: 38px;
  fill: #7fccf7;
  padding: 8px; }

._pick-text-alignment_101pd_1756 input:checked + ._svg-radio_101pd_875 {
  background-color: #4e99ec;
  fill: #d3edfe; }

._pick-text-alignment_101pd_1756 ._control-thumbnails_101pd_862:not(._with-title_101pd_937) {
  padding-top: 25px; }

hr._divider-long_101pd_1771, hr._divider-short_101pd_1771 {
  background-color: #dfe5eb;
  border: 0;
  height: 1px;
  margin: 0; }

hr._divider-short_101pd_1771 {
  margin: 0 24px; }

._rich-text-paragraph_101pd_1780 {
  font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif; }
  ._rich-text-paragraph_101pd_1780 ._rich-text-paragraph-title_101pd_1782 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 18px;
    -webkit-font-smoothing: antialiased;
    color: #3b4057;
    font-weight: 300;
    text-align: left;
    margin: 10px 0 0; }
  ._rich-text-paragraph_101pd_1780 ._rich-text-paragraph-content_101pd_1792 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    color: #3b4057;
    font-weight: 300;
    line-height: 21px;
    text-align: left;
    margin: 0; }
    ._rich-text-paragraph_101pd_1780 ._rich-text-paragraph-content_101pd_1792 a {
      color: #116dff;
      text-decoration: none; }
      ._rich-text-paragraph_101pd_1780 ._rich-text-paragraph-content_101pd_1792 a:hover {
        cursor: pointer;
        text-decoration: underline; }
    ._rich-text-paragraph_101pd_1780 ._rich-text-paragraph-content_101pd_1792 b,
    ._rich-text-paragraph_101pd_1780 ._rich-text-paragraph-content_101pd_1792 strong {
      font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      color: #3b4057;
      font-weight: normal; }

._listItemWithImage_101pd_1819 {
  height: 90px;
  cursor: pointer;
  padding: 13px 24px;
  background-color: #ffffff;
  display: flex; }
  ._listItemWithImage_101pd_1819:hover {
    background-color: #e7f0ff; }
    ._disabled_101pd_796._listItemWithImage_101pd_1819:hover {
      background-color: inherit;
      cursor: default; }
  ._listItemWithImage_101pd_1819 ._image_101pd_886 {
    display: inline-block;
    width: 90px;
    height: 90px; }
  ._listItemWithImage_101pd_1819 ._content_101pd_1834 {
    vertical-align: top;
    display: flex;
    min-width: 0;
    margin: 0 10px 0 16px;
    flex: 1;
    flex-direction: column;
    justify-content: center; }
    ._listItemWithImage_101pd_1819 ._content_101pd_1834 ._ellipsis_101pd_1842 {
      overflow: hidden;
      text-overflow: ellipsis; }
    ._listItemWithImage_101pd_1819 ._content_101pd_1834 ._title_101pd_1631 {
      font-family: HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-medium);
      font-size: 15px;
      -webkit-font-smoothing: antialiased;
      color: #000624;
      margin-bottom: 6px; }
      ._disabled_101pd_796._listItemWithImage_101pd_1819 ._content_101pd_1834 ._title_101pd_1631 {
        color: #7a7a7a; }
    ._listItemWithImage_101pd_1819 ._content_101pd_1834 ._desc_101pd_1855 {
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      color: #3b4057;
      line-height: 17px;
      max-height: 51px; }
      ._disabled_101pd_796._listItemWithImage_101pd_1819 ._content_101pd_1834 ._desc_101pd_1855 {
        color: #939393; }
  ._listItemWithImage_101pd_1819 ._list-item-indicator_101pd_1866 {
    display: flex;
    align-items: center; }
  ._listItemWithImage_101pd_1819 ._control-button_101pd_552._inline-link-button_101pd_1869 {
    display: inline;
    height: auto;
    font-size: inherit; }

._list-item-with-image-tooltip-content_101pd_1874 {
  margin: -18px; }
  ._list-item-with-image-tooltip-content_101pd_1874 p span {
    display: inline-block;
    padding-top: 6px; }

._listItem_101pd_1819 {
  height: 90px;
  cursor: pointer;
  padding: 13px 24px;
  background-color: #ffffff;
  display: flex; }
  ._listItem_101pd_1819:hover {
    background-color: #e7f0ff; }
  ._listItem_101pd_1819 ._image_101pd_886 {
    display: inline-block;
    width: 90px;
    height: 90px; }
  ._listItem_101pd_1819 ._content_101pd_1834 {
    width: 148px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin: 9px 10px 0 14px; }
    ._listItem_101pd_1819 ._content_101pd_1834._disabled_101pd_796 {
      cursor: default; }
    ._listItem_101pd_1819 ._content_101pd_1834 ._ellipsis_101pd_1842 {
      overflow: hidden;
      text-overflow: ellipsis; }
    ._listItem_101pd_1819 ._content_101pd_1834 ._title_101pd_1631 {
      font-family: HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-65Medi, HelveticaNeueW02-65Medi, HelveticaNeueW10-65Medi, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-medium);
      font-size: 15px;
      -webkit-font-smoothing: antialiased;
      color: #000624;
      margin: 0;
      height: 34px;
      line-height: 34px;
      flex-shrink: 0; }
    ._listItem_101pd_1819 ._content_101pd_1834 ._desc_101pd_1855 {
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      color: #3b4057;
      line-height: initial; }
  ._listItem_101pd_1819 ._expandSymbol_101pd_1922 {
    width: 28px;
    height: 28px; }

i._arrow-button_101pd_1926 {
  border: 2px solid #116dff;
  border-radius: 50%;
  display: inline-block;
  height: 21px;
  width: 21px;
  opacity: 0.67;
  cursor: pointer; }
  i._arrow-button_101pd_1926 svg {
    fill: #116dff;
    padding: 5px;
    vertical-align: middle; }
  i._arrow-button_101pd_1926:hover {
    background-color: #116dff; }
    i._arrow-button_101pd_1926:hover svg {
      fill: #fff; }
  i._arrow-button_101pd_1926._without-border_101pd_1942 {
    border: none;
    width: 9px;
    height: 9px;
    opacity: 1; }
    i._arrow-button_101pd_1926._without-border_101pd_1942 svg {
      width: 9px;
      padding: 0; }
    i._arrow-button_101pd_1926._without-border_101pd_1942:hover {
      background-color: transparent; }
      i._arrow-button_101pd_1926._without-border_101pd_1942:hover svg {
        fill: #116dff; }

:not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955 {
  overflow: hidden; }
  :not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955 input {
    display: none; }
    :not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955 input ~ svg,
    :not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955 input ~ ._label_101pd_625 {
      cursor: pointer; }
    :not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955 input:disabled ~ svg,
    :not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955 input:disabled ~ ._label_101pd_625 {
      cursor: default; }
  :not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955 span._label_101pd_625 {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: inherit;
    display: inline-block;
    vertical-align: middle; }
  :not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955._medium-scale_101pd_1972 svg {
    transform: scale(0.8);
    margin-bottom: -3px;
    vertical-align: middle;
    padding: 1px; }
  :not(._composite-toggle-switch_101pd_1955) > ._control-boolean_101pd_1955._no-scale_101pd_1977 svg {
    transform: scale(1);
    vertical-align: middle;
    padding: 1px; }

._control-boolean_101pd_1955._toggle-button_101pd_1982 {
  width: 32px;
  height: 32px;
  display: flex;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer; }
  ._control-boolean_101pd_1955._toggle-button_101pd_1982:hover {
    background-color: #e7f0ff; }
  ._control-boolean_101pd_1955._toggle-button_101pd_1982:active:not(._secondary_101pd_1992), ._control-boolean_101pd_1955._toggle-button_101pd_1982._checked_101pd_1992:not(._secondary_101pd_1992) {
    background-color: #116dff; }
    ._control-boolean_101pd_1955._toggle-button_101pd_1982:active:not(._secondary_101pd_1992):hover, ._control-boolean_101pd_1955._toggle-button_101pd_1982._checked_101pd_1992:not(._secondary_101pd_1992):hover {
      background-color: #5999ff; }
  ._control-boolean_101pd_1955._toggle-button_101pd_1982[disabled] {
    background-color: #fff; }
    ._control-boolean_101pd_1955._toggle-button_101pd_1982[disabled]:hover {
      background-color: #fff; }
  ._control-boolean_101pd_1955._toggle-button_101pd_1982:active._secondary_101pd_1992, ._control-boolean_101pd_1955._toggle-button_101pd_1982._checked_101pd_1992._secondary_101pd_1992 {
    background-color: transparent; }
    ._control-boolean_101pd_1955._toggle-button_101pd_1982:active._secondary_101pd_1992 svg, ._control-boolean_101pd_1955._toggle-button_101pd_1982._checked_101pd_1992._secondary_101pd_1992 svg {
      fill: #116dff; }
    ._control-boolean_101pd_1955._toggle-button_101pd_1982:active._secondary_101pd_1992:hover, ._control-boolean_101pd_1955._toggle-button_101pd_1982._checked_101pd_1992._secondary_101pd_1992:hover {
      background-color: #e7f0ff; }
  ._control-boolean_101pd_1955._toggle-button_101pd_1982._small_101pd_2006 {
    width: 24px;
    height: 24px; }

._radio-control_101pd_870 {
  cursor: pointer; }
  ._radio-control_101pd_870 input {
    display: none; }
  ._radio-control_101pd_870 span._label_101pd_625 {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; }

._circle-preloader_101pd_2020 {
  width: 15px;
  height: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -15px;
  margin-left: -15px;
  overflow: hidden;
  transform-origin: 100% 50%;
  animation: _semi-rotate_101pd_1 1s linear infinite; }
  ._wix-code-file-tree_101pd_2031 ._circle-preloader_101pd_2020 {
    width: 10px;
    height: 20px;
    margin-top: -10px;
    margin-left: -10px; }
  ._circle-preloader_101pd_2020::before {
    content: '';
    top: 0;
    left: 0;
    right: -100%;
    bottom: 0;
    border: 3px solid currentColor;
    border-color: currentColor transparent transparent currentColor;
    border-radius: 50%;
    position: absolute;
    transform: rotate(-45deg);
    animation: _inner-rotate_101pd_1 0.5s linear infinite alternate;
    color: #80b1ff; }
  ._circle-preloader_101pd_2020::after {
    content: '';
    top: 0;
    left: 0;
    right: -100%;
    bottom: 0;
    border: 3px solid currentColor;
    border-color: currentColor transparent transparent currentColor;
    border-radius: 50%;
    position: absolute;
    transform: rotate(-45deg);
    animation: _inner-rotate_101pd_1 0.5s linear infinite alternate;
    color: #116dff;
    opacity: 0; }
  ._circle-preloader_101pd_2020._white_101pd_2063::before {
    color: #f0f0f0; }
  ._circle-preloader_101pd_2020._white_101pd_2063::after {
    color: #f0f0f0; }
  ._install-preloader_101pd_2067 ._circle-preloader_101pd_2020 {
    position: relative; }

@keyframes _inner-rotate_101pd_1 {
  to {
    transform: rotate(115deg);
    opacity: 1; } }

@keyframes _semi-rotate_101pd_1 {
  from {
    transform: rotate(180deg);
    animation-timing-function: ease-out; }
  45% {
    transform: rotate(198deg); }
  55% {
    transform: rotate(234deg); }
  to {
    transform: rotate(540deg); } }

._video-container_101pd_2086 {
  border-radius: 6px;
  height: 174px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  width: 310px;
  z-index: 0; }
  ._video-container_101pd_2086 * {
    border: none;
    margin: 0;
    outline: none;
    padding: 0; }
  ._video-container_101pd_2086 > video {
    object-fit: cover;
    width: 100%; }
  ._video-container_101pd_2086 > ._controls_101pd_2102 {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%; }
    ._video-container_101pd_2086 > ._controls_101pd_2102[data-state='stopped'] > footer > ._actions_101pd_2111 > ._play-pause_101pd_2111, ._video-container_101pd_2086 > ._controls_101pd_2102[data-state='paused'] > footer > ._actions_101pd_2111 > ._play-pause_101pd_2111 {
      border-left: 8px solid #ffffff;
      border-top: 5px solid transparent;
      border-bottom: 5px solid transparent;
      height: 0;
      width: 0; }
    ._video-container_101pd_2086 > ._controls_101pd_2102[data-state='playing'] > ._main-action_101pd_2117,
    ._video-container_101pd_2086 > ._controls_101pd_2102[data-state='playing'] > footer {
      box-shadow: 0 0 10px 5px rgba(22, 45, 61, 0.2);
      opacity: 0; }
    ._video-container_101pd_2086 > ._controls_101pd_2102[data-state='playing']:hover > footer {
      opacity: 1; }
    ._video-container_101pd_2086 > ._controls_101pd_2102[data-state='playing'] > footer > ._actions_101pd_2111 > ._play-pause_101pd_2111 {
      height: 10px;
      border-left: 3px solid #ffffff;
      border-right: 3px solid #ffffff;
      width: 9px; }
    ._video-container_101pd_2086 > ._controls_101pd_2102 > ._main-action_101pd_2117,
    ._video-container_101pd_2086 > ._controls_101pd_2102 > footer {
      transition-duration: 0.3s;
      transition-property: opacity, box-shadow;
      will-change: opacity, box-shadow; }
    ._video-container_101pd_2086 > ._controls_101pd_2102 > ._main-action_101pd_2117 {
      background: rgba(22, 45, 61, 0.2);
      flex-grow: 1;
      position: relative; }
      ._video-container_101pd_2086 > ._controls_101pd_2102 > ._main-action_101pd_2117 > ._play-big_101pd_2137 {
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        transition-duration: 0.3s;
        transition-property: opacity;
        will-change: opacity;
        opacity: 0.7;
        border: 2px solid #ffffff;
        border-radius: 50%;
        background: rgba(22, 45, 61, 0.2);
        height: 80px;
        width: 80px; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > ._main-action_101pd_2117 > ._play-big_101pd_2137:hover {
          opacity: 1; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > ._main-action_101pd_2117 > ._play-big_101pd_2137:after {
          border-left: 30px solid #ffffff;
          border-top: 20px solid transparent;
          border-bottom: 20px solid transparent;
          height: 0;
          width: 0;
          content: '';
          display: inline-block;
          left: 4px;
          position: relative; }
    ._video-container_101pd_2086 > ._controls_101pd_2102 > footer {
      background: rgba(22, 45, 61, 0.2);
      box-sizing: border-box;
      height: 30px;
      padding: 0 18px;
      width: 100%; }
      ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._progress-bar_101pd_2169 {
        transition-duration: 0.3s;
        transition-property: opacity;
        will-change: opacity;
        opacity: 0.7;
        cursor: pointer;
        height: 10px;
        overflow: hidden;
        position: relative; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._progress-bar_101pd_2169:hover {
          opacity: 1; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._progress-bar_101pd_2169:before {
          top: 50%;
          transform: translateY(-50%);
          position: absolute;
          background: #ffffff;
          content: '';
          display: block;
          height: 2px;
          width: 100%; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._progress-bar_101pd_2169:hover > ._progress_101pd_2169,
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._progress-bar_101pd_2169:hover > ._progress_101pd_2169:after {
          box-shadow: 0 0 2px 0 #116dff; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._progress-bar_101pd_2169 > ._progress_101pd_2169 {
          top: 50%;
          transform: translateY(-50%);
          position: absolute;
          transition-duration: 0.3s;
          transition-property: box-shadow;
          will-change: box-shadow;
          background: #116dff;
          height: 2px;
          width: 0;
          display: block; }
          ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._progress-bar_101pd_2169 > ._progress_101pd_2169:after {
            top: 50%;
            transform: translateY(-50%);
            position: absolute;
            transition-duration: 0.3s;
            transition-property: box-shadow;
            will-change: box-shadow;
            background: inherit;
            border-radius: 50%;
            content: '';
            display: block;
            height: 8px;
            right: 0;
            width: 8px; }
      ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._actions_101pd_2111 {
        align-items: center;
        display: flex;
        height: calc( 100% - 14px); }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._actions_101pd_2111 button {
          transition-duration: 0.3s;
          transition-property: opacity;
          will-change: opacity;
          opacity: 0.7;
          background: none; }
          ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._actions_101pd_2111 button:hover {
            opacity: 1; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._actions_101pd_2111 > ._play-pause_101pd_2111 {
          margin-right: 10px; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._actions_101pd_2111 > ._stop_101pd_2231 {
          background: #ffffff;
          height: 10px;
          width: 10px; }
        ._video-container_101pd_2086 > ._controls_101pd_2102 > footer > ._actions_101pd_2111 > ._fullscreen_101pd_2235 {
          border: 2px solid #ffffff;
          height: 10px;
          margin-left: auto;
          width: 16px; }
  ._wix-store-switch-panel_101pd_2240 ._video-container_101pd_2086 {
    margin-bottom: 60px; }

._background-video-patterns-control_101pd_2243 ._class-v-overlay-pat-0-icon_101pd_2243,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-0-icon_101pd_2244 ._class-v-overlay-pat-0-icon_101pd_2243 {
  width: 51px;
  height: 51px;
  background-image: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/backgroundPanel/overlayPatternIcons/v-overlay-pat-0-icon.png");
  background-color: #e7f0ff;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #ffffff; }

._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-0-icon_101pd_2244:hover ._class-v-overlay-pat-0-icon_101pd_2243 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #80b1ff; }

._background-video-patterns-control_101pd_2243 ._selected_101pd_2256 ._class-v-overlay-pat-0-icon_101pd_2243,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-0-icon_101pd_2244 ._input-v-overlay-pat-0-icon_101pd_2257:checked ~ ._class-v-overlay-pat-0-icon_101pd_2243 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #116dff; }

._background-video-patterns-control_101pd_2243 ._class-v-overlay-pat-1-icon_101pd_2261,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-1-icon_101pd_2262 ._class-v-overlay-pat-1-icon_101pd_2261 {
  width: 51px;
  height: 51px;
  background-image: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/backgroundPanel/overlayPatternIcons/v-overlay-pat-1-icon.png");
  background-color: #e7f0ff;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #ffffff; }

._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-1-icon_101pd_2262:hover ._class-v-overlay-pat-1-icon_101pd_2261 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #80b1ff; }

._background-video-patterns-control_101pd_2243 ._selected_101pd_2256 ._class-v-overlay-pat-1-icon_101pd_2261,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-1-icon_101pd_2262 ._input-v-overlay-pat-1-icon_101pd_2275:checked ~ ._class-v-overlay-pat-1-icon_101pd_2261 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #116dff; }

._background-video-patterns-control_101pd_2243 ._class-v-overlay-pat-2-icon_101pd_2279,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-2-icon_101pd_2280 ._class-v-overlay-pat-2-icon_101pd_2279 {
  width: 51px;
  height: 51px;
  background-image: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/backgroundPanel/overlayPatternIcons/v-overlay-pat-2-icon.png");
  background-color: #e7f0ff;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #ffffff; }

._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-2-icon_101pd_2280:hover ._class-v-overlay-pat-2-icon_101pd_2279 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #80b1ff; }

._background-video-patterns-control_101pd_2243 ._selected_101pd_2256 ._class-v-overlay-pat-2-icon_101pd_2279,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-2-icon_101pd_2280 ._input-v-overlay-pat-2-icon_101pd_2293:checked ~ ._class-v-overlay-pat-2-icon_101pd_2279 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #116dff; }

._background-video-patterns-control_101pd_2243 ._class-v-overlay-pat-3-icon_101pd_2297,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-3-icon_101pd_2298 ._class-v-overlay-pat-3-icon_101pd_2297 {
  width: 51px;
  height: 51px;
  background-image: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/backgroundPanel/overlayPatternIcons/v-overlay-pat-3-icon.png");
  background-color: #e7f0ff;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #ffffff; }

._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-3-icon_101pd_2298:hover ._class-v-overlay-pat-3-icon_101pd_2297 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #80b1ff; }

._background-video-patterns-control_101pd_2243 ._selected_101pd_2256 ._class-v-overlay-pat-3-icon_101pd_2297,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-3-icon_101pd_2298 ._input-v-overlay-pat-3-icon_101pd_2311:checked ~ ._class-v-overlay-pat-3-icon_101pd_2297 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #116dff; }

._background-video-patterns-control_101pd_2243 ._class-v-overlay-pat-4-icon_101pd_2315,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-4-icon_101pd_2316 ._class-v-overlay-pat-4-icon_101pd_2315 {
  width: 51px;
  height: 51px;
  background-image: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/backgroundPanel/overlayPatternIcons/v-overlay-pat-4-icon.png");
  background-color: #e7f0ff;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #ffffff; }

._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-4-icon_101pd_2316:hover ._class-v-overlay-pat-4-icon_101pd_2315 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #80b1ff; }

._background-video-patterns-control_101pd_2243 ._selected_101pd_2256 ._class-v-overlay-pat-4-icon_101pd_2315,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-4-icon_101pd_2316 ._input-v-overlay-pat-4-icon_101pd_2329:checked ~ ._class-v-overlay-pat-4-icon_101pd_2315 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #116dff; }

._background-video-patterns-control_101pd_2243 ._class-v-overlay-pat-5-icon_101pd_2333,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-5-icon_101pd_2334 ._class-v-overlay-pat-5-icon_101pd_2333 {
  width: 51px;
  height: 51px;
  background-image: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/backgroundPanel/overlayPatternIcons/v-overlay-pat-5-icon.png");
  background-color: #e7f0ff;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #ffffff; }

._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-5-icon_101pd_2334:hover ._class-v-overlay-pat-5-icon_101pd_2333 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #80b1ff; }

._background-video-patterns-control_101pd_2243 ._selected_101pd_2256 ._class-v-overlay-pat-5-icon_101pd_2333,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-5-icon_101pd_2334 ._input-v-overlay-pat-5-icon_101pd_2347:checked ~ ._class-v-overlay-pat-5-icon_101pd_2333 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #116dff; }

._background-video-patterns-control_101pd_2243 ._class-v-overlay-pat-6-icon_101pd_2351,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-6-icon_101pd_2352 ._class-v-overlay-pat-6-icon_101pd_2351 {
  width: 51px;
  height: 51px;
  background-image: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/backgroundPanel/overlayPatternIcons/v-overlay-pat-6-icon.png");
  background-color: #e7f0ff;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #ffffff; }

._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-6-icon_101pd_2352:hover ._class-v-overlay-pat-6-icon_101pd_2351 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #80b1ff; }

._background-video-patterns-control_101pd_2243 ._selected_101pd_2256 ._class-v-overlay-pat-6-icon_101pd_2351,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-6-icon_101pd_2352 ._input-v-overlay-pat-6-icon_101pd_2365:checked ~ ._class-v-overlay-pat-6-icon_101pd_2351 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #116dff; }

._background-video-patterns-control_101pd_2243 ._class-v-overlay-pat-7-icon_101pd_2369,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-7-icon_101pd_2370 ._class-v-overlay-pat-7-icon_101pd_2369 {
  width: 51px;
  height: 51px;
  background-image: url("//static.parastorage.com/services/santa-resources/resources/editor/rEditor/backgroundPanel/overlayPatternIcons/v-overlay-pat-7-icon.png");
  background-color: #e7f0ff;
  border-radius: 4px;
  box-shadow: 0 0 0 2px #ffffff; }

._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-7-icon_101pd_2370:hover ._class-v-overlay-pat-7-icon_101pd_2369 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #80b1ff; }

._background-video-patterns-control_101pd_2243 ._selected_101pd_2256 ._class-v-overlay-pat-7-icon_101pd_2369,
._background-video-patterns-control_101pd_2243 ._control-v-overlay-pat-7-icon_101pd_2370 ._input-v-overlay-pat-7-icon_101pd_2383:checked ~ ._class-v-overlay-pat-7-icon_101pd_2369 {
  border-radius: 4px;
  box-shadow: 0 0 0 0 #ffffff, 0 0 0 2px #116dff; }

._background-video-patterns-control_101pd_2243 ._control-buttons-group_101pd_1224 {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 9px;
  padding-bottom: 24px;
  text-align: center; }
  ._background-video-patterns-control_101pd_2243 ._control-buttons-group_101pd_1224 input + span {
    max-width: 70px;
    max-height: 34px;
    line-height: 34px; }

._control-dock_101pd_2398 {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 0;
  position: relative; }
  ._control-dock_101pd_2398:hover ._info-icon_101pd_1047 {
    opacity: 1; }
  ._control-dock_101pd_2398 ._info-icon_101pd_1047 {
    float: right;
    opacity: 0; }
  ._control-dock_101pd_2398 ._dock-label_101pd_2409 {
    font-size: 14px;
    left: 25px;
    margin-bottom: 20px;
    display: block;
    color: #3b4057;
    margin-top: 20px; }
  ._control-dock_101pd_2398 ._dock-corners-wrapper_101pd_2416 {
    position: relative;
    margin: 0 auto;
    width: 185px; }
  ._control-dock_101pd_2398 label {
    font-size: 0;
    margin: 0;
    display: inline-block; }
    ._control-dock_101pd_2398 label input {
      display: none; }
      ._control-dock_101pd_2398 label input:checked + ._top_101pd_2426,
      ._control-dock_101pd_2398 label input:checked + ._right_101pd_1150,
      ._control-dock_101pd_2398 label input:checked + ._bottom_101pd_2428,
      ._control-dock_101pd_2398 label input:checked + ._left_101pd_1152 {
        border-color: #116dff;
        background: #d6e6fe; }
      ._control-dock_101pd_2398 label input:checked + ._middle_101pd_2432 {
        background: #116dff; }
    ._control-dock_101pd_2398 label ._square_101pd_935 {
      cursor: pointer;
      box-sizing: border-box;
      background: #e7f0ff;
      margin: 0;
      padding: 0;
      width: 61px;
      height: 43px;
      display: block; }
      ._control-dock_101pd_2398 label ._square_101pd_935._top_101pd_2426 {
        margin-bottom: 1px;
        margin-right: 1px;
        border-top: 12px solid #a8caff; }
        ._control-dock_101pd_2398 label ._square_101pd_935._top_101pd_2426:hover {
          border-top-color: #5999ff; }
        ._control-dock_101pd_2398 label ._square_101pd_935._top_101pd_2426._left_101pd_1152 {
          border-top-left-radius: 5px; }
        ._control-dock_101pd_2398 label ._square_101pd_935._top_101pd_2426._right_101pd_1150 {
          border-top-right-radius: 5px; }
      ._control-dock_101pd_2398 label ._square_101pd_935._left_101pd_1152 {
        border-left: 12px solid #a8caff;
        margin-left: 0; }
        ._control-dock_101pd_2398 label ._square_101pd_935._left_101pd_1152:hover {
          border-left-color: #5999ff; }
      ._control-dock_101pd_2398 label ._square_101pd_935._middle_101pd_2432 {
        margin-left: 1px;
        margin-right: 1px; }
        ._control-dock_101pd_2398 label ._square_101pd_935._middle_101pd_2432:hover {
          background: #5999ff; }
      ._control-dock_101pd_2398 label ._square_101pd_935._right_101pd_1150 {
        border-right: 12px solid #a8caff;
        margin-right: 0; }
        ._control-dock_101pd_2398 label ._square_101pd_935._right_101pd_1150:hover {
          border-right-color: #5999ff; }
      ._control-dock_101pd_2398 label ._square_101pd_935._bottom_101pd_2428 {
        margin-top: 1px;
        margin-right: 1px;
        border-bottom: 12px solid #a8caff; }
        ._control-dock_101pd_2398 label ._square_101pd_935._bottom_101pd_2428:hover {
          border-bottom-color: #5999ff; }
        ._control-dock_101pd_2398 label ._square_101pd_935._bottom_101pd_2428._left_101pd_1152 {
          border-bottom-left-radius: 5px; }
        ._control-dock_101pd_2398 label ._square_101pd_935._bottom_101pd_2428._right_101pd_1150 {
          border-bottom-right-radius: 5px;
          margin-right: 0; }
    ._control-dock_101pd_2398 label._disabled_101pd_796 ._square_101pd_935 {
      background: #f0f0f0;
      border-color: #d5d5d5; }
      ._control-dock_101pd_2398 label._disabled_101pd_796 ._square_101pd_935:hover {
        background: #f0f0f0;
        border-color: #d5d5d5; }
      ._control-dock_101pd_2398 label._disabled_101pd_796 ._square_101pd_935._middle_101pd_2432 {
        background: #ffffff; }
        ._control-dock_101pd_2398 label._disabled_101pd_796 ._square_101pd_935._middle_101pd_2432:hover {
          background: #ffffff; }
  ._control-dock_101pd_2398 ._dashed_101pd_2489 {
    position: absolute;
    box-sizing: border-box;
    pointer-events: none; }
    ._control-dock_101pd_2398 ._dashed_101pd_2489._horizontal_101pd_1316 {
      border-top: 1px dotted #80b1ff;
      border-bottom: 1px dotted #80b1ff;
      height: 45px;
      top: 43px;
      left: 12px;
      right: 12px; }
    ._control-dock_101pd_2398 ._dashed_101pd_2489._vertical_101pd_1335 {
      border-left: 1px dotted #80b1ff;
      border-right: 1px dotted #80b1ff;
      width: 63px;
      top: 12px;
      bottom: 12px;
      left: 61px; }

._drag-area-control_101pd_2508 {
  min-height: 100px; }
  ._drag-area-control_101pd_2508._with-border_101pd_2510 {
    border-radius: 14px;
    border: 2px dashed #d6e6fe;
    margin: 12px; }
    ._fonts-upload-panel_101pd_2514 ._drag-area-control_101pd_2508._with-border_101pd_2510 {
      min-height: 299px; }
    ._drag-area-control_101pd_2508._with-border_101pd_2510._dragging_101pd_2516 {
      border: 2px dashed #80b1ff; }
  ._fonts-upload-panel_101pd_2514 ._drag-area-control_101pd_2508 {
    min-height: 327px; }

._splitter_101pd_2521 {
  display: flex; }

._splitter-divider_101pd_2524 {
  z-index: 1500; }
  ._splitter-divider-horizontal_101pd_2526 {
    width: 100%;
    height: 10px;
    margin: -5px 0;
    cursor: row-resize; }
  ._splitter-divider-vertical_101pd_2531 {
    width: 10px;
    height: 100%;
    margin: 0 -5px;
    cursor: col-resize;
    color: #b6c1cd; }

._ide-splitter_101pd_2538 ._splitter-divider-horizontal_101pd_2526 {
  height: 18px;
  margin: -6px 0 -12px 0; }

._splitter-divider-handle_101pd_2542 {
  background-color: #e7f0ff;
  border: 1px solid #dfe5eb;
  cursor: pointer;
  height: 52px;
  position: relative;
  text-align: center;
  top: calc(50% - (52px / 2));
  width: 11px; }
  ._splitter-divider-handle_101pd_2542._open_101pd_2551 {
    border-bottom-left-radius: 7px;
    border-right: none;
    border-top-left-radius: 7px;
    left: calc(-50% - 3px); }
  ._splitter-divider-handle_101pd_2542._closed_101pd_1490 {
    border-bottom-right-radius: 7px;
    border-left: none;
    border-top-right-radius: 7px;
    left: 50%; }
  ._splitter-divider-handle_101pd_2542 ._symbol_101pd_552 {
    height: 12px;
    position: relative;
    top: 19px;
    width: 5px; }
    ._splitter-divider-handle_101pd_2542 ._symbol_101pd_552 path {
      fill: #000624; }
  ._splitter-divider-handle_101pd_2542:hover ._symbol_101pd_552 path {
    fill: #116dff; }

._paginated-thumbnails_101pd_2571 {
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  padding-bottom: 36px; }
  ._paginated-thumbnails_101pd_2571 ._paginated-thumbnails-content_101pd_2575 {
    position: relative;
    display: flex;
    flex-direction: row;
    overflow-x: scroll;
    scroll-behavior: auto;
    overscroll-behavior-x: contain;
    scroll-snap-type: x mandatory; }
    ._paginated-thumbnails_101pd_2571 ._paginated-thumbnails-content_101pd_2575 ._composite-thumbnail-wrapper_101pd_2583 {
      box-sizing: border-box;
      flex-shrink: 0;
      scroll-snap-align: start;
      width: 100%; }
  ._paginated-thumbnails_101pd_2571 ._paginated-tumbnails-pager_101pd_2588 {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-bottom: 18px;
    text-align: center; }
    ._paginated-thumbnails_101pd_2571 ._paginated-tumbnails-pager_101pd_2588 li {
      display: inline-block;
      margin: 0 6px; }
    ._paginated-thumbnails_101pd_2571 ._paginated-tumbnails-pager_101pd_2588 button {
      border-radius: 50%;
      overflow: hidden;
      width: 12px;
      height: 12px;
      background: #dfe5eb; }
      ._paginated-thumbnails_101pd_2571 ._paginated-tumbnails-pager_101pd_2588 button._selected_101pd_2256 {
        background: #116dff; }
      ._paginated-thumbnails_101pd_2571 ._paginated-tumbnails-pager_101pd_2588 button span {
        visibility: hidden; }
  ._paginated-thumbnails_101pd_2571 ._hide-scrollbar_101pd_2607 {
    scrollbar-width: none;
    -ms-overflow-style: -ms-autohiding-scrollbar; }
    ._paginated-thumbnails_101pd_2571 ._hide-scrollbar_101pd_2607::-webkit-scrollbar {
      display: none; }

._control-accordion_101pd_2613 {
  position: relative; }
  ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580 {
    background-color: #fff; }
    ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580:hover {
      background-color: #e7f0ff; }
    ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580 > ._selected-indicator_101pd_2619 {
      margin-left: 12px;
      vertical-align: middle; }
    ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580 > ._control-label_101pd_402 {
      font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      color: #000624;
      font-weight: 500;
      text-align: left;
      padding: 19px 0 18px 0;
      display: inline-block;
      line-height: 13px; }
    ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580 > ._accordion-icon_101pd_2634 {
      margin: 19px 15px 18px 24px; }
      ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580 > ._accordion-icon_101pd_2634._open_101pd_2551 {
        margin: 22px 12px 20px 24px; }

._light-accordion_101pd_2639 ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580:hover {
  background-color: #fff; }
  ._light-accordion_101pd_2639 ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580:hover > ._control-label_101pd_402 {
    color: #116dff; }
  ._light-accordion_101pd_2639 ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580:hover ._symbol-accordionClose_101pd_2643,
  ._light-accordion_101pd_2639 ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580:hover ._symbol-accordionOpen_101pd_2644 {
    fill: #116dff; }

._light-accordion_101pd_2639 ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580 > ._control-label_101pd_402 {
  color: #3b4057; }

._light-accordion_101pd_2639 ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580 ._symbol-accordionClose_101pd_2643,
._light-accordion_101pd_2639 ._control-accordion_101pd_2613 > ._accordion-header_101pd_1580 ._symbol-accordionOpen_101pd_2644 {
  fill: #3b4057; }

._control-text-input_101pd_1607 {
  position: relative;
  text-align: left;
  display: inline-block;
  width: 100%; }
  ._control-text-input_101pd_1607 > ._text-input-label_101pd_2659 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    font-weight: 300;
    color: #3b4057;
    text-align: left;
    display: block;
    overflow: hidden;
    line-height: 18px;
    max-height: 34px;
    padding: 7px 30px 6px 12px; }
    ._is-disabled_101pd_2673._control-text-input_101pd_1607 > ._text-input-label_101pd_2659 {
      color: #939393; }
    ._developer-toolbar-content_101pd_2675 ._control-text-input_101pd_1607 > ._text-input-label_101pd_2659 {
      padding: 10px 5px 10px 1px; }
    ._wix-code-find-replace_101pd_2677 ._control-text-input_101pd_1607 > ._text-input-label_101pd_2659 {
      padding-top: 6px; }
  ._success_101pd_2679._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309 :not(:focus), ._error_101pd_2679._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309 :not(:focus), ._warning_101pd_2679._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309 :not(:focus) {
    width: calc(100% - 43px);
    padding-right: 0; }
  ._instant-error_101pd_2682._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309:focus {
    border: 1px solid #e62214; }
  ._color-format_101pd_2684 ._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309 {
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    padding-left: 62px;
    height: 24px;
    line-height: 24px;
    width: 100%; }
  ._developer-toolbar-content_101pd_2675 ._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309 {
    width: 100%;
    height: 24px;
    font-size: 12px;
    cursor: pointer;
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    color: #174165;
    font-weight: 700;
    padding-left: 8px; }
  ._wix-code-find-replace_101pd_2677 ._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309 {
    height: 22px;
    font-size: 14px;
    color: #3b4057;
    border: 1px solid #5999ff;
    box-shadow: inset 0 0 3px 0 rgba(0, 90, 132, 0.25); }
    ._wix-code-find-replace_101pd_2677:hover ._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309 {
      background-color: transparent;
      cursor: text; }
    ._wix-code-find-replace_101pd_2677 ._control-text-input_101pd_1607 > ._input-container_101pd_309 ._input_101pd_309:hover {
      background-color: transparent;
      cursor: text; }
  ._control-text-input_101pd_1607 > ._input-container_101pd_309 ._developer-toolbar-content_101pd_2675 {
    flex: 1; }
  ._color-format_101pd_2684 ._control-text-input_101pd_1607 > ._input-container_101pd_309 {
    display: block; }
  ._wix-code-find-replace_101pd_2677 ._control-text-input_101pd_1607 > ._input-container_101pd_309 {
    width: 190px; }
  ._control-text-input_101pd_1607 ._validation-icon_101pd_2721 {
    position: absolute;
    right: 12px;
    top: 9px;
    cursor: pointer;
    visibility: hidden;
    font-size: 0; }
    ._error_101pd_2679._control-text-input_101pd_1607:not(._focused_101pd_2728) ._validation-icon_101pd_2721._validation-icon-error_101pd_2728 {
      visibility: visible; }
    ._success_101pd_2679._control-text-input_101pd_1607:not(._focused_101pd_2728) ._validation-icon_101pd_2721._validation-icon-success_101pd_2730 {
      visibility: visible; }
    ._warning_101pd_2679._control-text-input_101pd_1607:not(._focused_101pd_2728) ._validation-icon_101pd_2721._validation-icon-warning_101pd_2732 {
      visibility: visible; }
    ._color-format_101pd_2684 ._control-text-input_101pd_1607 ._validation-icon_101pd_2721 {
      top: 0; }
    ._wix-code-find-replace_101pd_2677 ._control-text-input_101pd_1607 ._validation-icon_101pd_2721 {
      display: none; }
  ._control-text-input_101pd_1607 ._validation-icon-wrapper_101pd_2738 {
    position: absolute;
    top: -3px;
    right: 2px; }
    ._developer-toolbar-content_101pd_2675 ._control-text-input_101pd_1607 ._validation-icon-wrapper_101pd_2738 {
      position: relative;
      top: -20px;
      left: 36px;
      right: unset; }
    ._has-label_101pd_1629._control-text-input_101pd_1607 ._validation-icon-wrapper_101pd_2738 {
      top: 37px;
      right: 25px; }
      ._has-label_101pd_1629._control-text-input_101pd_1607 ._validation-icon-wrapper_101pd_2738 ._validation-icon_101pd_2721 {
        top: 0;
        right: -11px; }
  ._color-format_101pd_2684 ._control-text-input_101pd_1607:before {
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    content: '#';
    position: absolute;
    left: 55px;
    top: 4px; }
  ._developer-toolbar-content_101pd_2675 ._control-text-input_101pd_1607 {
    display: flex;
    align-items: center; }
  ._wix-code-file-tree_101pd_2031 ._control-text-input_101pd_1607 > ._input-container_101pd_309 > ._input_101pd_309 {
    height: 22px;
    font-size: 14px; }
  ._wix-code-pages-tree_101pd_2769 ._control-text-input_101pd_1607 > ._input-container_101pd_309 > ._input_101pd_309 {
    height: 22px;
    font-size: 14px; }

._developer-toolbar-content_101pd_2675 ._control-text-input_101pd_1607._focused_101pd_2728 > ._input-container_101pd_309 ._input_101pd_309 {
  font-weight: 400; }

._selective-text-input_101pd_2776 {
  position: relative;
  display: flex;
  align-items: center; }
  ._selective-text-input_101pd_2776 ._textInput_101pd_2780 {
    margin-left: 16px;
    margin-right: 80px;
    padding: 0;
    width: auto; }
    ._selective-text-input_101pd_2776 ._textInput_101pd_2780 > input {
      font-size: 16px;
      line-height: 16px; }
  ._selective-text-input_101pd_2776 ._control-mandatory_101pd_1172 {
    display: flex;
    align-items: center;
    margin-left: 11px; }

._input-slider_101pd_2793 {
  position: relative; }
  ._input-slider_101pd_2793 > label {
    display: none; }
  ._input-slider_101pd_2793._has-label_101pd_1629 > label {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    display: block;
    margin-bottom: 5px;
    color: #3b4057;
    text-align: left;
    font-weight: 300;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  ._input-slider_101pd_2793 ._info-icon_101pd_1047 {
    display: none;
    position: absolute;
    top: 0;
    right: 0; }
  ._input-slider_101pd_2793 ._sliderArea_101pd_2816 {
    position: relative; }
  ._input-slider_101pd_2793 ._slider_101pd_2816 {
    position: relative;
    height: 36px;
    margin: 0 81px 0 0;
    padding-top: 3px; }
    ._input-slider_101pd_2793 ._slider_101pd_2816 ._line_101pd_2823 {
      position: absolute;
      top: 17px;
      left: 0;
      height: 6px;
      width: 100%;
      background-color: #d6e6fe;
      border-radius: 3px;
      box-shadow: inset 0 1px 0 0 #c0e1f2;
      cursor: pointer; }
    ._input-slider_101pd_2793 ._slider_101pd_2816 ._knobContainer_101pd_2833 {
      margin-right: 16px;
      position: relative; }
    ._input-slider_101pd_2793 ._slider_101pd_2816 ._coloredLine_101pd_2836 {
      position: absolute;
      top: 14px;
      left: 0;
      height: 6px;
      background-color: #116dff;
      border-radius: 3px;
      box-shadow: inset 0 1px 0 0 #116dff;
      will-change: width;
      cursor: pointer; }
    ._input-slider_101pd_2793 ._slider_101pd_2816 ._sliderKnob_101pd_2846 {
      position: absolute;
      content: '';
      top: 9px;
      display: inline-block;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: 0 1px 3px 0 rgba(52, 94, 151, 0.6);
      width: 16px;
      height: 16px;
      cursor: pointer;
      will-change: left;
      transition: box-shadow 0.25s ease-in-out 0s; }
      ._input-slider_101pd_2793 ._slider_101pd_2816 ._sliderKnob_101pd_2846:after {
        position: absolute;
        content: '';
        display: inline-block;
        border-radius: 50%;
        background-color: #116dff;
        width: 8px;
        height: 8px;
        left: 4px;
        top: 4px;
        cursor: pointer; }
      ._input-slider_101pd_2793 ._slider_101pd_2816 ._sliderKnob_101pd_2846:hover {
        box-shadow: 0 1px 2px 2px rgba(138, 209, 250, 0.58); }
  ._input-slider_101pd_2793 ._input-stepper_101pd_852 {
    position: absolute;
    right: 0; }
    ._input-slider_101pd_2793 ._input-stepper_101pd_852 ._input_101pd_309 {
      text-align: right; }
  ._input-slider_101pd_2793:hover ._input-stepper_101pd_852,
  ._input-slider_101pd_2793:hover ._input-stepper_101pd_852 > :not(._units-container_101pd_2878) {
    background-color: #e7f0ff; }
  ._input-slider_101pd_2793:hover ._info-icon_101pd_1047 {
    display: inline-block; }
  ._input-slider_101pd_2793._disabled_101pd_796 {
    opacity: 0.5; }
  ._color-picker-input-with-opacity_101pd_2884 ._input-slider_101pd_2793 {
    margin-right: 40px; }

._input-slider-opacity_101pd_2887 {
  position: relative; }
  ._input-slider-opacity_101pd_2887 > label {
    display: none; }
  ._input-slider-opacity_101pd_2887._has-label_101pd_1629 > label {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    display: block;
    margin-bottom: 5px;
    color: #3b4057;
    text-align: left;
    font-weight: 300;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  ._input-slider-opacity_101pd_2887 ._info-icon_101pd_1047 {
    display: none;
    position: absolute;
    top: 0;
    right: 0; }
  ._input-slider-opacity_101pd_2887 ._sliderArea_101pd_2816 {
    position: relative; }
  ._input-slider-opacity_101pd_2887 ._slider_101pd_2816 {
    position: relative;
    height: 36px;
    margin: 0 81px 0 0;
    padding-top: 3px; }
    ._input-slider-opacity_101pd_2887 ._slider_101pd_2816 ._empty-line_101pd_2917 {
      position: absolute;
      top: 16px;
      left: 0;
      height: 8px;
      width: 100%;
      border-radius: 3px;
      background-image: linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc);
      background-position: 1px 1px, 5px 5px;
      background-size: 8px 8px;
      cursor: pointer; }
    ._input-slider-opacity_101pd_2887 ._slider_101pd_2816 ._line_101pd_2823 {
      position: absolute;
      top: 16px;
      left: 0;
      height: 8px;
      width: 100%;
      border-radius: 3px;
      box-shadow: inset 0 1px 0 0 #c0e1f2;
      cursor: pointer; }
    ._input-slider-opacity_101pd_2887 ._slider_101pd_2816 ._knobContainer_101pd_2833 {
      margin-right: 16px;
      position: relative; }
    ._input-slider-opacity_101pd_2887 ._slider_101pd_2816 ._sliderKnob_101pd_2846 {
      position: absolute;
      content: '';
      top: 9px;
      display: inline-block;
      border-radius: 50%;
      background-color: #fff;
      box-shadow: 0 1px 3px 0 rgba(52, 94, 151, 0.6);
      width: 16px;
      height: 16px;
      cursor: pointer;
      will-change: left;
      transition: box-shadow 0.25s ease-in-out 0s; }
      ._input-slider-opacity_101pd_2887 ._slider_101pd_2816 ._sliderKnob_101pd_2846:after {
        position: absolute;
        content: '';
        display: inline-block;
        border-radius: 50%;
        background-color: #116dff;
        width: 8px;
        height: 8px;
        left: 4px;
        top: 4px;
        cursor: pointer; }
      ._input-slider-opacity_101pd_2887 ._slider_101pd_2816 ._sliderKnob_101pd_2846:hover {
        box-shadow: 0 1px 2px 2px rgba(138, 209, 250, 0.58); }
  ._input-slider-opacity_101pd_2887 ._input-stepper_101pd_852 {
    position: absolute;
    right: 0; }
    ._input-slider-opacity_101pd_2887 ._input-stepper_101pd_852 ._input_101pd_309 {
      text-align: right; }
  ._input-slider-opacity_101pd_2887:hover ._input-stepper_101pd_852,
  ._input-slider-opacity_101pd_2887:hover ._input-stepper_101pd_852 > :not(._units-container_101pd_2878) {
    background-color: #e7f0ff; }
  ._input-slider-opacity_101pd_2887:hover ._info-icon_101pd_1047 {
    display: inline-block; }
  ._input-slider-opacity_101pd_2887._disabled_101pd_796 {
    opacity: 0.5; }
  ._color-picker-input-with-opacity_101pd_2884 ._input-slider-opacity_101pd_2887 {
    margin-right: 40px; }

._input-stepper_101pd_852 {
  border-radius: 4px;
  border: 1px solid transparent;
  width: 56px;
  padding: 0 6px;
  position: relative;
  text-align: left;
  display: inline-block; }
  ._input-stepper_101pd_852._no-padding_101pd_2989 {
    padding: 0; }
  ._input-stepper_101pd_852:after {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    content: '';
    border: 1px solid transparent;
    border-radius: 4px;
    pointer-events: none; }
    ._edited_101pd_3001._input-stepper_101pd_852:after {
      border-color: #9cccf6;
      box-shadow: inset 0 0 3px 0 rgba(0, 90, 132, 0.25); }
    ._bad-value_101pd_3004._input-stepper_101pd_852:after {
      border-color: #f1726b; }
  ._input-stepper_101pd_852._disabled_101pd_796 {
    opacity: 0.5; }
  ._units-dd-expanded_101pd_3008._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001),
  ._units-dd-expanded_101pd_3008._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001) > ._input_101pd_309,
  ._units-dd-expanded_101pd_3008._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001) > ._units-container_101pd_2878 > ._units_101pd_2878,
  ._units-dd-expanded_101pd_3008._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001) > ._units-container_101pd_2878, ._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001):hover,
  ._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001):hover > ._input_101pd_309,
  ._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001):hover > ._units-container_101pd_2878 > ._units_101pd_2878,
  ._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001):hover > ._units-container_101pd_2878 {
    background-color: #d6e6fe;
    color: #3b4057;
    cursor: pointer; }
  ._units-dd-expanded_101pd_3008._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001):after, ._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001):hover:after {
    border-color: #d6e6fe; }
  ._input-stepper_101pd_852:not(._disabled_101pd_796):not(._bad-value_101pd_3004):not(._edited_101pd_3001) > ._input_101pd_309:focus {
    background-color: #d6e6fe;
    color: #3b4057;
    cursor: pointer; }
  ._input-stepper_101pd_852._edited_101pd_3001 {
    background-color: transparent !important; }
    ._stepper-with-svg_101pd_3026 ._input-stepper_101pd_852._edited_101pd_3001 > ._input_101pd_309 {
      width: 100%; }
  ._input-stepper_101pd_852._small_101pd_2006 {
    width: 45px;
    padding: 2px 2px 2px 0; }
  ._input-stepper_101pd_852._has-units_101pd_3031._with-units-dd_101pd_3031 {
    width: 64px;
    padding-right: 0; }
    ._input-stepper_101pd_852._has-units_101pd_3031._with-units-dd_101pd_3031 > ._input_101pd_309 {
      width: 28px; }
  ._input-stepper_101pd_852 > ._input_101pd_309 {
    border: none;
    outline: none;
    text-align: center;
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-size: 18px;
    height: 36px;
    line-height: 36px;
    padding: 0 7px;
    width: calc(100% - 14px);
    display: inline-block;
    color: #000624; }
    ._disabled_101pd_796._input-stepper_101pd_852 > ._input_101pd_309 {
      color: #7a7a7a;
      background: transparent; }
    ._has-units_101pd_3031._input-stepper_101pd_852 > ._input_101pd_309 {
      width: 70%;
      padding: 0;
      text-align: right;
      display: inline-block; }
    ._small_101pd_2006._input-stepper_101pd_852 > ._input_101pd_309 {
      font-size: 12px;
      height: 18px;
      line-height: 18px; }
    ._edited_101pd_3001._input-stepper_101pd_852 > ._input_101pd_309 {
      background-color: transparent !important;
      cursor: text !important; }
    ._input-stepper_101pd_852:not(._edited_101pd_3001) > ._input_101pd_309 {
      cursor: default; }
    ._input-stepper_101pd_852 > ._input_101pd_309::selection {
      background-color: #e7f0ff; }
      ._input-stepper_101pd_852:not(._edited_101pd_3001) > ._input_101pd_309::selection {
        background-color: transparent; }
    ._color-format_101pd_2684 ._input-stepper_101pd_852 > ._input_101pd_309 {
      font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      height: 24px;
      line-height: 24px; }
  ._input-stepper_101pd_852:edited > ._units-container_101pd_2878 {
    background-color: transparent !important; }
  ._edited_101pd_3001._input-stepper_101pd_852:not(._with-units-dd_101pd_3031) > ._units-container_101pd_2878 {
    visibility: hidden; }
  ._input-stepper_101pd_852 > ._units-container_101pd_2878 > ._units_101pd_2878 {
    line-height: 36px;
    height: 36px;
    width: 1%;
    display: inline-block;
    white-space: nowrap;
    padding: 0 7px 0 1px; }
    ._disabled_101pd_796._input-stepper_101pd_852 > ._units-container_101pd_2878 > ._units_101pd_2878 {
      color: #7a7a7a; }
    ._small_101pd_2006._input-stepper_101pd_852 > ._units-container_101pd_2878 > ._units_101pd_2878 {
      height: 18px;
      line-height: 18px;
      font-size: 12px; }
    ._color-format_101pd_2684 ._input-stepper_101pd_852 > ._units-container_101pd_2878 > ._units_101pd_2878 {
      height: 24px;
      line-height: 24px; }
  ._control-angle_101pd_793 ._input-stepper_101pd_852 {
    position: absolute;
    top: 52px;
    left: 138px;
    width: 40px; }
    ._control-angle_101pd_793 ._input-stepper_101pd_852 > ._units_101pd_2878,
    ._control-angle_101pd_793 ._input-stepper_101pd_852 > ._input_101pd_309 {
      height: 28px;
      line-height: 28px; }
    ._control-angle_101pd_793 ._input-stepper_101pd_852._has-units_101pd_3031 > ._input_101pd_309 {
      width: 78%; }
  ._control-angle_101pd_793 > ._circle_101pd_798:active + ._input-stepper_101pd_852,
  ._control-angle_101pd_793 > ._circle_101pd_798:active + ._input-stepper_101pd_852 > ._units_101pd_2878,
  ._control-angle_101pd_793 > ._circle_101pd_798:active + ._input-stepper_101pd_852 > ._stepper_101pd_3026,
  ._control-angle_101pd_793:hover ._input-stepper_101pd_852,
  ._control-angle_101pd_793:hover ._input-stepper_101pd_852 > ._units_101pd_2878,
  ._control-angle_101pd_793:hover ._input-stepper_101pd_852 > ._stepper_101pd_3026 {
    background-color: #edf7ff; }
  ._color-format_101pd_2684 ._input-stepper_101pd_852 {
    width: 100%;
    box-sizing: border-box; }
  ._stepper-with-svg_101pd_3026 ._input-stepper_101pd_852 {
    text-align: left;
    padding-left: 0;
    border-radius: 4px;
    margin-top: 5px;
    overflow: hidden;
    margin-left: 12px;
    padding-right: 11px; }
    ._stepper-with-svg_101pd_3026 ._input-stepper_101pd_852:after {
      border-radius: 4px; }
    ._stepper-with-svg_101pd_3026 ._input-stepper_101pd_852 > ._units-container_101pd_2878 > ._units_101pd_2878,
    ._stepper-with-svg_101pd_3026 ._input-stepper_101pd_852 > ._input_101pd_309 {
      height: 17px;
      line-height: 17px;
      font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif; }
    ._stepper-with-svg_101pd_3026 ._input-stepper_101pd_852 > ._units-container_101pd_2878 > ._units_101pd_2878 {
      height: 17px; }
    ._stepper-with-svg_101pd_3026 ._input-stepper_101pd_852 > ._input_101pd_309 {
      height: 18px;
      color: #384f68;
      font-size: 12px;
      padding-right: 2px;
      padding-left: 1px;
      line-height: 14px; }

._stepper-with-svg_101pd_3026 {
  margin-right: 12px;
  font-size: 12px; }
  ._stepper-with-svg_101pd_3026 ._symbol_101pd_552 {
    fill: #384f68;
    position: relative;
    bottom: 3px;
    margin-left: 2px; }
    ._stepper-with-svg_101pd_3026 ._symbol_101pd_552._safari_101pd_3151 {
      top: 3px;
      bottom: 0; }
    ._stepper-with-svg_101pd_3026 ._symbol_101pd_552:hover {
      fill: #2b81cb;
      cursor: pointer; }
  ._stepper-with-svg_101pd_3026 ._edited_101pd_3001 + ._symbol_101pd_552 {
    fill: #bcbcbc;
    pointer-events: none;
    cursor: default; }

._property-form_101pd_3162 ._errorMessage_101pd_3162 {
  color: #f00; }

._property-form_101pd_3162 span._label_101pd_625 {
  display: block;
  margin-bottom: 5px; }

._menu-panel_101pd_3169 {
  min-width: 250px;
  min-height: 300px; }
  ._menu-panel_101pd_3169 header {
    font-size: 16px;
    color: #000000;
    position: relative;
    margin-bottom: 10px; }
    ._menu-panel_101pd_3169 header a {
      position: absolute;
      top: -10px;
      right: 0;
      width: 25px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      font-size: 16px;
      color: #000;
      text-decoration: none; }
  ._menu-panel_101pd_3169 ul {
    max-height: 350px;
    overflow-y: auto;
    overflow-x: hidden; }
    ._menu-panel_101pd_3169 ul li {
      color: #333;
      border-bottom: 1px solid #fff;
      padding: 5px 5px;
      cursor: pointer; }
      ._menu-panel_101pd_3169 ul li:hover {
        background-color: #b2f3ff; }

._dropdown_101pd_349 {
  font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--wbu-font-weight-regular);
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  position: relative; }
  ._dropdown_101pd_349._font-family-dd_101pd_3207._toolbar-mode_101pd_3207, ._dropdown_101pd_349._text-style-dd_101pd_3207._toolbar-mode_101pd_3207 {
    display: inline-block;
    vertical-align: middle;
    margin: 4px 5px;
    padding-right: 0;
    min-width: 140px; }
  ._dropdown_101pd_349._context-menu_101pd_3213 {
    width: 24px;
    height: 24px;
    border: 1px solid #000;
    border-radius: 50%;
    line-height: 24px;
    text-align: center; }
    ._dropdown_101pd_349._context-menu_101pd_3213._wix-code-pages-tree-dd_101pd_3220, ._dropdown_101pd_349._context-menu_101pd_3213._wix-code-file-tree-dd_101pd_3220 {
      border: none;
      width: 16px;
      height: 16px;
      line-height: 16px; }
  ._dropdown_101pd_349._units-dd_101pd_3008 {
    display: inline-block;
    padding-left: 5px; }
  ._dropdown_101pd_349:focus,
  ._dropdown_101pd_349 > ._dd_101pd_3229:focus {
    outline: none; }
  ._dropdown_101pd_349 > ._dd_101pd_3229,
  ._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304 {
    margin: 0;
    padding: 0; }
  ._dropdown_101pd_349 > ._dropdown-label_101pd_3235 {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
    margin: 0 0 3px 0;
    padding: 0;
    color: #3b4057;
    font-size: 14px;
    font-weight: 300;
    line-height: 18px;
    text-align: left;
    width: calc(100% - 20px); }
    ._select_101pd_2256._disabled_101pd_796._dropdown_101pd_349 > ._dropdown-label_101pd_3235 {
      color: #939393; }
  ._dropdown_101pd_349 > ._dd_101pd_3229 {
    position: relative;
    cursor: pointer; }
    ._disabled_101pd_796._dropdown_101pd_349 > ._dd_101pd_3229 {
      cursor: default; }
    ._context-menu_101pd_3213._dropdown_101pd_349 > ._dd_101pd_3229 {
      height: 100%; }
    ._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
      position: relative;
      box-sizing: border-box;
      color: #000624;
      font-size: 18px;
      height: 36px;
      line-height: 36px;
      min-height: 36px;
      padding: 0 30px 0 0;
      margin: 0; }
      ._input-slider_101pd_2793._dropdown_101pd_349:hover > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
        color: #116dff; }
      ._text-link-dd_101pd_3270._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
        height: 32px;
        line-height: 32px;
        min-height: 32px;
        width: 32px;
        padding-right: 0; }
      ._disabled_101pd_796._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
        color: #7a7a7a; }
      ._context-menu_101pd_3213._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
        height: 30px;
        line-height: 30px;
        min-height: 30px; }
      ._units-dd_101pd_3008._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
        padding-right: 12px;
        font-size: 14px;
        line-height: 14px;
        height: 14px;
        min-height: 14px; }
      ._wix-code-pages-tree-dd_101pd_3220._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
        height: 16px;
        line-height: 16px;
        min-height: 16px; }
      ._wix-code-file-tree-dd_101pd_3220._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
        height: 16px;
        line-height: 16px;
        min-height: 16px; }
      ._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 > ._symbol-more_101pd_3296 > ._notification_101pd_3296 {
        font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
        font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
        font-weight: var(--wbu-font-weight-regular);
        font-size: 12px;
        -webkit-font-smoothing: antialiased;
        width: 20px;
        height: 20px;
        top: -10px;
        font-size: 10px;
        border-radius: 10px;
        line-height: 18px;
        border: 1px solid #fff;
        position: absolute;
        left: 10px;
        background-color: #ffc233;
        color: #fff;
        box-sizing: border-box; }
      ._dropdown_101pd_349 > ._dd_101pd_3229 > ._selected-container_101pd_3258 > ._symbol-more_101pd_3296._shrink_101pd_3314 > ._notification_101pd_3296 {
        width: 14px;
        height: 14px;
        top: -7px;
        font-size: 7px;
        border-radius: 7px;
        line-height: 12px; }
    ._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304 {
      border: 2px solid #116dff;
      border-radius: 50%;
      content: '';
      display: block;
      height: 22px;
      opacity: 0.6;
      right: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 22px; }
      ._select_101pd_2256._disabled_101pd_796._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304 {
        border-color: #bcbcbc; }
        ._select_101pd_2256._disabled_101pd_796._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304:hover {
          background-color: transparent; }
      ._font-family-dd_101pd_3207._toolbar-mode_101pd_3207._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304, ._units-dd_101pd_3008._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304 {
        border: none;
        width: 9px;
        opacity: 1; }
        ._font-family-dd_101pd_3207._toolbar-mode_101pd_3207._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304:hover, ._units-dd_101pd_3008._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304:hover {
          background-color: transparent; }
      ._input-stepper_101pd_852._dropdown_101pd_349:hover > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304 {
        opacity: 1; }
      ._input-slider_101pd_2793:hover ._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304 {
        opacity: 1; }
      ._units-dd_101pd_3008._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304 {
        opacity: 0; }
      ._toolbar-mode_101pd_3207._font-family-dd_101pd_3207._dropdown_101pd_349 > ._dd_101pd_3229 > ._expand_101pd_1922._arrow_101pd_1304 {
        right: 8px; }

._combo-box_101pd_3352 > ._combo-box-input_101pd_3352 {
  border: none;
  width: 100%;
  padding: 0; }
  ._font-family-dd_101pd_3207._toolbar-mode_101pd_3207 ._combo-box_101pd_3352 > ._combo-box-input_101pd_3352 {
    font-size: 16px; }
  ._combo-box_101pd_3352 > ._combo-box-input_101pd_3352:focus {
    outline: none; }

._font-family-dd_101pd_3207._toolbar-mode_101pd_3207 ._combo-box_101pd_3352._selected_101pd_2256 {
  width: 130px; }

._dropdown_101pd_349:not(._disabled_101pd_796):hover ._combo-box_101pd_3352 {
  color: #116dff; }

._dropdown_101pd_349._combobox_101pd_3367 ._combo-box_101pd_3352 {
  overflow: inherit;
  text-overflow: inherit; }

._dropdown-options_101pd_349 {
  left: 0;
  position: fixed;
  top: 0; }
  ._dropdown-options_101pd_349._expanded_101pd_3375 {
    bottom: 0;
    right: 0;
    z-index: 5998 !important; }
  ._dropdown-options_101pd_349 > ._options_101pd_3379 {
    display: none;
    position: fixed;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.15), 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 18px 0 rgba(0, 0, 0, 0.08);
    flex-direction: column;
    max-height: 100%; }
    ._expanded_101pd_3375._dropdown-options_101pd_349 > ._options_101pd_3379 {
      display: flex !important; }
      ._expanded_101pd_3375._dropdown-options_101pd_349 > ._options_101pd_3379._scroll_101pd_3389._up_101pd_3389 > ._arrow_101pd_1304._top_101pd_2426,
      ._expanded_101pd_3375._dropdown-options_101pd_349 > ._options_101pd_3379._scroll_101pd_3389._down_101pd_3390 > ._arrow_101pd_1304._bottom_101pd_2428 {
        visibility: visible; }
    ._select_101pd_2256._dropdown-options_101pd_349 > ._options_101pd_3379, ._combobox_101pd_3367._dropdown-options_101pd_349 > ._options_101pd_3379 {
      overflow: hidden; }
    ._context-menu_101pd_3213._dropdown-options_101pd_349 > ._options_101pd_3379._tag-triangle_101pd_3394._tag-left_101pd_3394._tag-side-top_101pd_3394:before, ._context-menu_101pd_3213._dropdown-options_101pd_349 > ._options_101pd_3379._tag-triangle_101pd_3394._tag-right_101pd_3394._tag-side-top_101pd_3394:before {
      top: 17px; }
    ._context-menu_101pd_3213._dropdown-options_101pd_349 > ._options_101pd_3379._tag-triangle_101pd_3394._tag-left_101pd_3394._tag-side-bottom_101pd_3396:before, ._context-menu_101pd_3213._dropdown-options_101pd_349 > ._options_101pd_3379._tag-triangle_101pd_3394._tag-right_101pd_3394._tag-side-bottom_101pd_3396:before {
      bottom: 17px; }
    ._dropdown-options_101pd_349 > ._options_101pd_3379,
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._top_101pd_2426._arrow_101pd_1304,
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._list_101pd_1819,
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._options-footer_101pd_3401,
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._bottom_101pd_2428._arrow_101pd_1304,
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._mouse-events-blocker_101pd_3403 {
      margin: 0;
      padding: 0; }
    ._dropdown-options_101pd_349 > ._options_101pd_3379:focus {
      outline: none; }
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._list_101pd_1819 {
      display: block;
      max-height: 100%;
      overflow: hidden; }
      ._context-menu_101pd_3213._dropdown-options_101pd_349 > ._options_101pd_3379 > ._list_101pd_1819 {
        box-sizing: border-box;
        padding: 10px 0; }
      ._combobox_101pd_3367._dropdown-options_101pd_349 > ._options_101pd_3379 > ._list_101pd_1819 {
        overflow-y: auto; }
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._arrow_101pd_1304 {
      background-color: rgba(255, 255, 255, 0.93);
      display: block;
      font-size: 8px;
      height: 36px;
      left: 0;
      opacity: 0.6;
      position: absolute;
      width: 100%;
      visibility: hidden;
      z-index: 1; }
      ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._arrow_101pd_1304._top_101pd_2426 {
        top: 0;
        transform: rotateX(180deg); }
      ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._arrow_101pd_1304._bottom_101pd_2428 {
        bottom: 0; }
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._options-footer_101pd_3401 {
      flex-shrink: 0; }
      ._combobox_101pd_3367._dropdown-options_101pd_349 > ._options_101pd_3379 > ._options-footer_101pd_3401 {
        font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
        font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
        font-weight: var(--wbu-font-weight-regular);
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
        background-color: #fff;
        box-shadow: 0 -1px 23px 0 #fff;
        color: #116dff;
        line-height: 35px;
        height: 35px;
        padding: 0 24px;
        z-index: 0; }
    ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._mouse-events-blocker_101pd_3403 {
      display: none; }
      ._dropdown-options_101pd_349 > ._options_101pd_3379 > ._mouse-events-blocker_101pd_3403._visible_101pd_3450 {
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        left: 0;
        top: 0; }

._dropdown-option_101pd_349 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  position: relative; }
  ._dropdown-option_101pd_349._hovered_101pd_3470:not(._separator_101pd_3470):not(._disabled_101pd_796) {
    background-color: #e7f0ff; }
  ._dropdown-option_101pd_349._disabled_101pd_796 {
    cursor: default; }
    ._dropdown-option_101pd_349._disabled_101pd_796 ._wix-code-context-menu-item_101pd_3474 {
      color: #939393; }
    ._dropdown-option_101pd_349._disabled_101pd_796 path {
      fill: #939393; }
  ._dropdown-option_101pd_349._level1_101pd_3478 {
    padding-left: 30px; }
  ._dropdown-option_101pd_349._level2_101pd_3480 {
    padding-left: 40px; }
  ._dropdown-option_101pd_349._level3_101pd_3482 {
    padding-left: 50px; }
  ._dropdown-option_101pd_349._separator_101pd_3470 {
    height: 1px; }
  ._dropdown-option_101pd_349._font-option_101pd_3486 {
    height: 24px;
    padding: 0 14px; }
  ._dropdown-option_101pd_349._units-dropdown_101pd_3489 {
    text-align: center;
    padding: 0; }
  ._dropdown-option_101pd_349._link-dd-option_101pd_3492 {
    padding: 4px 11px; }
  ._optgroup-list_101pd_3494 ._dropdown-option_101pd_349 {
    padding: 0 40px; }
    ._dropdown-options_101pd_349._combobox_101pd_3367 ._optgroup-list_101pd_3494 ._dropdown-option_101pd_349 {
      padding: 0 24px; }
  ._dropdown-options_101pd_349._select_101pd_2256 ._dropdown-option_101pd_349._selected_101pd_2256,
  ._dropdown-options_101pd_349._combobox_101pd_3367 ._dropdown-option_101pd_349._selected_101pd_2256 {
    background-color: #116dff;
    color: #fff; }
  ._units-dd_101pd_3008 ._dropdown-option_101pd_349 {
    padding: 0 10px; }

._dropdown-optgroup_101pd_3505 ._optgroup-label_101pd_3505 {
  background-color: #f5f5f5;
  color: #3b4057;
  font-size: 14px;
  font-weight: 300;
  height: 35px;
  line-height: 35px;
  padding: 0 20px;
  margin: 0; }
  ._combobox_101pd_3367 ._dropdown-optgroup_101pd_3505 ._optgroup-label_101pd_3505 {
    height: 36px;
    padding: 0 24px;
    background-color: #f7f8f8;
    border-top: 1px solid #dfe5eb;
    border-bottom: 1px solid #dfe5eb;
    cursor: default; }

._dropdown-optgroup_101pd_3505 > ._optgroup-list_101pd_3494 {
  padding: 0; }

._dropdown_101pd_349._select_101pd_2256 ._dropdown-selected_101pd_3525 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

._icons-menu-button-wrapper_101pd_3530 {
  position: relative;
  height: 34px;
  width: 34px;
  display: inline-block;
  cursor: pointer; }
  ._icons-menu-button-wrapper_101pd_3530:hover, ._icons-menu-button-wrapper_101pd_3530._active_101pd_3536 {
    background: #eaf7ff;
    border-radius: 6px; }
  ._icons-menu-button-wrapper_101pd_3530 ._small-indicator_101pd_3539 {
    position: absolute;
    box-sizing: border-box;
    width: 4px;
    height: 4px;
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-bottom: 2px solid #116dff;
    border-right: 2px solid #116dff;
    bottom: 3px;
    right: 3px; }

._dropdown_101pd_349._icons-menu_101pd_3530 > ._dd_101pd_3229 > ._selected-container_101pd_3258 {
  padding: 0; }

._dropdown-options_101pd_349._icons-menu_101pd_3530 ._options_101pd_3379 {
  padding: 12px 0; }
  ._dropdown-options_101pd_349._icons-menu_101pd_3530 ._options_101pd_3379._tag-triangle_101pd_3394._tag-top_101pd_3556::before, ._dropdown-options_101pd_349._icons-menu_101pd_3530 ._options_101pd_3379._tag-triangle_101pd_3394._tag-bottom_101pd_3556::before {
    left: calc(50% - 5px); }
  ._dropdown-options_101pd_349._icons-menu_101pd_3530 ._options_101pd_3379 ._dropdown-option_101pd_349 {
    padding: 0 18px; }
    ._dropdown-options_101pd_349._icons-menu_101pd_3530 ._options_101pd_3379 ._dropdown-option_101pd_349 ._symbol-wrapper_101pd_3560 {
      height: 100%;
      display: inline-block; }
      ._dropdown-options_101pd_349._icons-menu_101pd_3530 ._options_101pd_3379 ._dropdown-option_101pd_349 ._symbol-wrapper_101pd_3560 ._symbol_101pd_552 {
        padding: 0 10px 0 0;
        margin-bottom: -2px; }

._control-checkable-text-input_101pd_3567 {
  margin: 0 12px 0 30px; }
  ._control-checkable-text-input_101pd_3567 ._checkable-text-input_101pd_3569 {
    align-items: center;
    display: flex;
    height: 59px; }
    ._control-checkable-text-input_101pd_3567 ._checkable-text-input_101pd_3569 ._control-text-input_101pd_1607,
    ._settings-panel_101pd_3574 ._control-checkable-text-input_101pd_3567 ._checkable-text-input_101pd_3569 ._control-text-input_101pd_1607 {
      margin: 0 0 0 12px; }
  ._control-checkable-text-input_101pd_3567 + hr._divider-long_101pd_1771 {
    margin: 0 24px 0 30px; }

._control-numeric-input_101pd_3579 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box; }
  ._control-numeric-input_101pd_3579 ._label_101pd_625 {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-user-select: none;
    user-select: none;
    padding: 18px 0 16px 24px;
    vertical-align: middle;
    color: #3b4057;
    font-size: 14px;
    line-height: 1.8;
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif; }
  ._control-numeric-input_101pd_3579 ._input-stepper_101pd_852 {
    margin-right: 6px; }

._domain-input-container_101pd_3601 {
  position: relative; }
  ._domain-input-container_101pd_3601 ._domain-input-loader_101pd_3603 {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    width: 18px; }
  ._domain-input-container_101pd_3601._with-edit-buttons_101pd_3611 ._domain-input-loader_101pd_3603 {
    right: 78px; }
  ._domain-input-container_101pd_3601 ._input-validation-icon_101pd_3613 {
    visibility: hidden; }
  ._domain-input-container_101pd_3601 ._input-editable-url_101pd_3615 {
    min-width: 100%; }
  ._domain-input-container_101pd_3601 ._control-button_101pd_552._btn-edit_101pd_3617 {
    width: auto;
    min-width: 66px;
    max-width: 106px;
    padding: 0 12px; }

._control-radio-list_101pd_3623 {
  padding: 10px 20px 5px 24px;
  box-sizing: border-box;
  position: relative;
  width: 100%; }
  ._control-radio-list_101pd_3623 ._title_101pd_1631 {
    color: #3b4057;
    display: inline-block;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 3px;
    text-align: left;
    font-weight: 300;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap; }
  ._control-radio-list_101pd_3623 label {
    display: block;
    padding: 15px 0 15px 4px;
    margin: 0;
    cursor: pointer;
    border-bottom: 1px solid #dfe5eb; }
    ._control-radio-list_101pd_3623 label div:nth-of-type(1) {
      margin: 0 0 0 14px;
      vertical-align: middle;
      box-sizing: border-box;
      display: inline-block; }
      ._control-radio-list_101pd_3623 label div:nth-of-type(1) div {
        display: table-cell;
        width: 54px;
        height: 42px;
        text-align: center;
        vertical-align: middle;
        border: 1px solid #e5e5e5;
        border-radius: 5px; }
        ._control-radio-list_101pd_3623 label div:nth-of-type(1) div span {
          font-size: 30px; }
    ._control-radio-list_101pd_3623 label:first-child {
      border-top: none; }
    ._control-radio-list_101pd_3623 label:last-child {
      border-bottom-color: transparent; }
    ._control-radio-list_101pd_3623 label._highlight-on-hover_101pd_3664:hover span:nth-of-type(2) {
      color: #5c99e8; }
    ._control-radio-list_101pd_3623 label._highlight-on-hover_101pd_3664:hover ._editor-mode-option-symbol_101pd_3666 svg g {
      fill: #5c99e8; }
  ._control-radio-list_101pd_3623 span:nth-of-type(2) {
    display: inline-block;
    color: #2a3742;
    margin-left: 14px;
    vertical-align: middle; }
  ._control-radio-list_101pd_3623 ._info-icon_101pd_1047 {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px; }
  ._control-radio-list_101pd_3623:hover ._info-icon_101pd_1047 {
    display: inline-block; }
  ._control-radio-list_101pd_3623 input {
    display: none; }
    ._control-radio-list_101pd_3623 input + span {
      border-radius: 50%;
      display: inline-block;
      height: 12px;
      width: 12px;
      box-shadow: 0 0 0 1px #5c99e8;
      border: solid 5px #fff;
      transition-property: background-color, border-width;
      transition-duration: 0.15s;
      box-sizing: border-box;
      vertical-align: middle; }
    ._control-radio-list_101pd_3623 input:checked + span {
      background-color: #5c99e8;
      border-width: 1px; }

._control-checkbox-with-button_101pd_3697 {
  white-space: nowrap; }
  ._control-checkbox-with-button_101pd_3697 ._controls-wrapper_101pd_3699 {
    height: 24px;
    display: flex;
    align-items: center; }
    ._control-checkbox-with-button_101pd_3697 ._controls-wrapper_101pd_3699 ._checkbox-button_101pd_3703 {
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      height: 24px;
      line-height: 24px;
      display: none;
      border-radius: 12px;
      margin-left: auto;
      overflow: visible; }
  ._control-checkbox-with-button_101pd_3697:hover {
    background-color: #e7f0ff; }
    ._control-checkbox-with-button_101pd_3697:hover ._checkbox-button_101pd_3703 {
      display: inline-block;
      opacity: 1;
      transition: 0.2s opacity; }
  ._control-checkbox-with-button_101pd_3697:not(:hover) ._checkbox-button_101pd_3703 {
    opacity: 0;
    width: 0;
    padding: 0; }

._color-scheme-picker_101pd_3726 ._control-switch_101pd_3726._invert-color-toggle_101pd_3726 {
  padding-top: 10px; }

._color-scheme-picker_101pd_3726 ._control-switch_101pd_3726 ._label_101pd_625 {
  align-self: baseline; }

._action-container_101pd_3732 {
  position: relative;
  height: 72px;
  cursor: pointer; }
  ._action-container_101pd_3732 > ._action-symbol_101pd_3736 {
    position: absolute;
    top: 0;
    bottom: 0;
    background: #116dff;
    border-radius: 50%;
    margin: auto 26px;
    width: 24px;
    height: 24px; }
    ._action-container_101pd_3732:hover > ._action-symbol_101pd_3736 {
      background: #5999ff; }
    ._symbol-right_101pd_3747._action-container_101pd_3732 > ._action-symbol_101pd_3736 {
      right: 0; }
    ._action-container_101pd_3732 > ._action-symbol_101pd_3736 > ._symbol_101pd_552 {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      padding-right: 1px; }
      ._action-container_101pd_3732 > ._action-symbol_101pd_3736 > ._symbol_101pd_552 > path {
        fill: #fff; }
  ._action-container_101pd_3732 > ._action-label_101pd_3759 {
    position: absolute;
    top: 0;
    bottom: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: auto 24px;
    height: 20px;
    color: #116dff;
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-size: 14px; }
    ._action-container_101pd_3732:hover > ._action-label_101pd_3759 {
      text-decoration: underline;
      color: #5999ff; }
    ._symbol-left_101pd_3774._action-container_101pd_3732 > ._action-label_101pd_3759 {
      left: 34px;
      right: 0; }
    ._symbol-right_101pd_3747._action-container_101pd_3732 > ._action-label_101pd_3759 {
      right: 45px;
      left: 0; }

._media-button_101pd_3781 > ._media-button-filename-text_101pd_3781 {
  text-align: center;
  margin-top: 16px; }
  ._media-button_101pd_3781 > ._media-button-filename-text_101pd_3781 > ._wrapper_101pd_3784 > span {
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: #000624;
    vertical-align: middle;
    display: inline-block;
    max-width: calc(100% - 48px); }

._image-preview_101pd_3798 {
  background-color: #e7f0ff;
  box-sizing: border-box;
  height: 155px;
  position: relative;
  text-align: center;
  width: 288px; }
  ._image-preview_101pd_3798 ._image-wrapper_101pd_3805 {
    font-size: 0;
    height: 100%; }
    ._image-preview_101pd_3798 ._image-wrapper_101pd_3805 > ._image_101pd_886 {
      width: 100%;
      height: 100%; }
  ._image-preview_101pd_3798 ._button-wrapper_101pd_555 {
    background-color: rgba(177, 221, 248, 0.4);
    bottom: 0;
    display: block;
    height: 54px;
    left: 0;
    position: absolute;
    white-space: nowrap;
    width: 100%; }
    ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111 {
      background-color: #fff;
      border: 0;
      border-radius: 17px;
      color: #116dff;
      cursor: pointer;
      font-size: 14px;
      height: 32px;
      line-height: 32px;
      margin-bottom: 0 !important;
      margin-top: 11px !important;
      padding: 0;
      outline: none;
      text-overflow: clip;
      vertical-align: top; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111._has-icon_101pd_3835._has-label_101pd_1629 span {
        padding: 0 34px; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111._has-icon_101pd_3835:not(._has-label_101pd_1629) {
        padding: 0 9px;
        margin-left: 0;
        margin-right: 10px; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(1) {
        min-width: 167px;
        max-width: 204px; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(2) {
        margin-right: 24px; }
        ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(2),
        ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(2) + button {
          width: 108px; }
        ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(2) + button {
          margin-left: 0; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(3) {
        width: 152px;
        margin-left: 24px;
        margin-right: 12px;
        float: left; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(2):nth-last-of-type(2) {
        float: right;
        margin-right: 24px; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(3):nth-last-of-type(1) {
        float: right;
        margin-right: 12px; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:hover {
        background-color: #e7f0ff; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111:active {
        background-color: #fff; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111 > ._button-content_101pd_3866 {
        position: relative; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111 svg {
        width: 14px;
        height: 32px; }
        ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111 svg._symbol-with-label_101pd_552 {
          top: 0;
          left: 12px;
          position: absolute; }
        ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111 svg * {
          fill: #116dff; }
      ._image-preview_101pd_3798 ._button-wrapper_101pd_555 button._action_101pd_2111 span {
        font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
        font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
        font-weight: var(--wbu-font-weight-regular);
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
        color: #116dff;
        line-height: 17px;
        text-align: left;
        left: 3px;
        position: relative; }
  ._image-preview_101pd_3798 ._placeholder-wrapper_101pd_3888 svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -75%); }
  ._image-preview_101pd_3798 ._placeholder-wrapper_101pd_3888._symbol-in-the-middle_101pd_3893 svg {
    transform: translate(-50%, -50%); }
  ._image-preview_101pd_3798 ._placeholder-wrapper_101pd_3888 ._corner-borders_101pd_3895:before, ._image-preview_101pd_3798 ._placeholder-wrapper_101pd_3888 ._corner-borders_101pd_3895:after {
    border: solid #5c99e8;
    content: '';
    height: 10px;
    margin: 25px;
    position: absolute;
    width: 10px; }
  ._image-preview_101pd_3798 ._placeholder-wrapper_101pd_3888 ._corner-borders_101pd_3895._top_101pd_2426:before {
    border-width: 1px 0 0 1px;
    left: 0;
    top: 0; }
  ._image-preview_101pd_3798 ._placeholder-wrapper_101pd_3888 ._corner-borders_101pd_3895._top_101pd_2426:after {
    border-width: 1px 1px 0 0;
    right: 0;
    top: 0; }
  ._image-preview_101pd_3798 ._placeholder-wrapper_101pd_3888 ._corner-borders_101pd_3895._bottom_101pd_2428:before {
    border-width: 0 0 1px 1px;
    bottom: 0;
    left: 0; }
  ._image-preview_101pd_3798 ._placeholder-wrapper_101pd_3888 ._corner-borders_101pd_3895._bottom_101pd_2428:after {
    border-width: 0 1px 1px 0;
    bottom: 0;
    right: 0; }
  ._image-preview_101pd_3798 ._arrow-button_101pd_1926 {
    border-radius: 50%;
    box-shadow: 0 1px 3px 0 rgba(52, 94, 151, 0.43);
    cursor: pointer;
    height: 24px;
    position: absolute;
    top: 50%;
    width: 24px; }
    ._image-preview_101pd_3798 ._arrow-button_101pd_1926:after {
      border-left: 2px solid #0199ef;
      border-top: 2px solid #0199ef;
      content: '';
      height: 6px;
      left: calc(50% - 2px);
      position: absolute;
      top: calc(50% - 4px);
      transform: rotate(-45deg);
      width: 6px; }
    ._image-preview_101pd_3798 ._arrow-button_101pd_1926._prev_101pd_3936 {
      left: 0;
      margin: -12px 0 0 12px; }
    ._image-preview_101pd_3798 ._arrow-button_101pd_1926._next_101pd_3939 {
      right: 0;
      margin: -12px 12px 0 0; }
      ._image-preview_101pd_3798 ._arrow-button_101pd_1926._next_101pd_3939:after {
        left: calc(50% - 5px);
        top: calc(50% - 4px);
        transform: rotate(135deg); }
    ._image-preview_101pd_3798 ._arrow-button_101pd_1926:hover {
      background-color: rgba(56, 153, 236, 0.9); }
      ._image-preview_101pd_3798 ._arrow-button_101pd_1926:hover:after {
        border-color: #fff; }
    ._image-preview_101pd_3798 ._arrow-button_101pd_1926[disabled] {
      cursor: default; }
    ._image-preview_101pd_3798 ._arrow-button_101pd_1926, ._image-preview_101pd_3798 ._arrow-button_101pd_1926[disabled], ._image-preview_101pd_3798 ._arrow-button_101pd_1926[disabled]:hover {
      background-color: rgba(255, 255, 255, 0.9); }
    ._image-preview_101pd_3798 ._arrow-button_101pd_1926[disabled]:after, ._image-preview_101pd_3798 ._arrow-button_101pd_1926[disabled]:hover:after {
      border-color: #bcbcbc; }

._video-input_101pd_3957 {
  width: 288px;
  height: 155px;
  box-sizing: border-box;
  background-color: #e7f0ff;
  position: relative;
  text-align: center; }
  ._video-input_101pd_3957 ._video-wrapper_101pd_3964 {
    height: 100%;
    font-size: 0; }
    ._video-input_101pd_3957 ._video-wrapper_101pd_3964 > iframe {
      border: none; }
    ._video-input_101pd_3957 ._video-wrapper_101pd_3964,
    ._video-input_101pd_3957 ._video-wrapper_101pd_3964 > iframe {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%; }
  ._video-input_101pd_3957 ._button-wrapper_101pd_555 {
    height: 54px;
    display: block;
    bottom: 0;
    left: 0;
    position: absolute;
    white-space: nowrap;
    width: 100%;
    background-color: rgba(177, 221, 248, 0.4); }
    ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111 {
      height: 32px;
      line-height: 32px;
      margin-bottom: 0 !important;
      border: 0;
      border-radius: 17px;
      background-color: #fff;
      cursor: pointer;
      outline: none;
      color: #116dff;
      font-size: 14px;
      vertical-align: top;
      text-overflow: clip; }
      ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111._has-icon_101pd_3835 {
        padding-left: 0; }
      ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(1) {
        width: 167px; }
      ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(2) {
        margin-right: 23px; }
        ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(2),
        ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111:nth-of-type(1):nth-last-of-type(2) + button {
          width: calc(50% - 2 * 23px); }
      ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111:hover {
        background-color: #e7f0ff; }
      ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111:active {
        background-color: #fff; }
      ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111 svg {
        float: left;
        margin: 0 20px 0 0 !important;
        width: 14px;
        height: 32px; }
      ._video-input_101pd_3957 ._button-wrapper_101pd_555 button._action_101pd_2111 span {
        font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
        font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
        font-weight: var(--wbu-font-weight-regular);
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
        color: #116dff;
        line-height: 17px;
        text-align: left; }
  ._video-input_101pd_3957 ._placeholder-wrapper_101pd_3888 svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -75%); }
    ._video-input_101pd_3957 ._placeholder-wrapper_101pd_3888 svg path {
      fill: #116dff; }
  ._video-input_101pd_3957 ._video-controls_101pd_4032 {
    width: 100%;
    height: 100%; }
    ._video-input_101pd_3957 ._video-controls_101pd_4032 ._blocking-layer_101pd_4035 {
      background: #000;
      width: 100%;
      height: 100%; }
      ._video-input_101pd_3957 ._video-controls_101pd_4032 ._blocking-layer_101pd_4035._play_101pd_1705 {
        opacity: 0; }
      ._video-input_101pd_3957 ._video-controls_101pd_4032 ._blocking-layer_101pd_4035._pause_101pd_4041 {
        opacity: 0.4; }
    ._video-input_101pd_3957 ._video-controls_101pd_4032 ._pause-button_101pd_4043,
    ._video-input_101pd_3957 ._video-controls_101pd_4032 ._play-button_101pd_4044 {
      width: 44px;
      height: 44px;
      border: 2px solid #fff;
      position: absolute;
      margin: 46px 0 65px 0;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 50%;
      top: 6px; }
    ._video-input_101pd_3957 ._video-controls_101pd_4032 ._pause-button_101pd_4043 ._pause_101pd_4041 {
      display: block;
      border-left: 5px solid #fff;
      border-right: 5px solid #fff;
      width: 10%;
      height: 40%;
      top: 50%;
      left: 50%;
      position: absolute;
      transform: translate(-50%, -50%); }
    ._video-input_101pd_3957 ._video-controls_101pd_4032 ._pause-button_101pd_4043:hover {
      border-color: #116dff;
      cursor: pointer; }
      ._video-input_101pd_3957 ._video-controls_101pd_4032 ._pause-button_101pd_4043:hover ._pause_101pd_4041 {
        border-left-color: #116dff;
        border-right-color: #116dff;
        cursor: pointer; }
    ._video-input_101pd_3957 ._video-controls_101pd_4032 ._play-button_101pd_4044 ._triangle_101pd_4071 {
      width: 0;
      height: 0;
      position: relative;
      display: block;
      border-color: inherit;
      border-left: 24px solid #fff;
      border-bottom: 14px transparent solid;
      border-top: 14px transparent solid;
      top: 50%;
      left: calc(50% + 4px);
      transform: translate(-50%, -50%); }
    ._video-input_101pd_3957 ._video-controls_101pd_4032 ._play-button_101pd_4044:hover {
      border-color: #116dff;
      cursor: pointer; }
      ._video-input_101pd_3957 ._video-controls_101pd_4032 ._play-button_101pd_4044:hover ._triangle_101pd_4071 {
        border-left-color: #116dff;
        border-right-color: #116dff;
        cursor: pointer; }

._video-selector_101pd_4091._bg-panel-top_101pd_4091 {
  position: relative;
  height: 162px; }

._video-selector_101pd_4091 ._bg-panel-preview_101pd_4095 {
  height: 100%; }

._video-selector_101pd_4091 ._bg-panel-preview-media_101pd_4098 {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #e7f0ff; }

._video-selector_101pd_4091 ._bg-panel-top-actions_101pd_4104 {
  position: absolute;
  bottom: 0;
  height: 54px;
  width: 100%;
  background: rgba(177, 221, 248, 0.4);
  display: flex;
  align-items: center;
  justify-content: center; }
  ._video-selector_101pd_4091 ._bg-panel-top-actions_101pd_4104 ._bg-panel-action_101pd_4113 ._btn-confirm-secondary_101pd_587 {
    background-color: #ffffff; }
    ._video-selector_101pd_4091 ._bg-panel-top-actions_101pd_4104 ._bg-panel-action_101pd_4113 ._btn-confirm-secondary_101pd_587:hover {
      background-color: #e7f0ff; }

._video-selector_101pd_4091 ._change-media-button-text_101pd_4118 {
  padding-left: 10px; }

._video-selector_101pd_4091 ._bg-panel-preview-buttons_101pd_4121 {
  position: relative;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center; }

._video-preview_101pd_4128 {
  position: relative;
  height: 162px;
  background: #000000; }
  ._video-preview__cover_101pd_4132 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center; }
    ._video-preview__cover_101pd_4132 > ._media-panel-play-button_101pd_4141 {
      margin: 0; }
  ._video-preview__poster_101pd_4143 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%; }
  ._video-preview__player_101pd_4149 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%; }
  ._video-preview__embedded-player_101pd_4155 {
    height: 100%;
    font-size: 0;
    opacity: 0.8; }
    ._video-preview__embedded-player_101pd_4155 > iframe {
      border: none; }
    ._video-preview__embedded-player_101pd_4155,
    ._video-preview__embedded-player_101pd_4155 > iframe {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%; }
  ._video-preview__button-wrapper_101pd_4168 {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: rgba(177, 221, 248, 0.4);
    display: flex;
    align-items: center;
    justify-content: center; }
  ._video-preview_101pd_4128 ._change-media-button-text_101pd_4118 {
    padding-left: 10px; }

._control-rich-text_101pd_4179 ._video-type-selector_101pd_4179 {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0;
  margin: 8px -6px -4px; }

._video-type-selector__item_101pd_4186 {
  flex: 0 0 51px;
  max-width: 51px;
  margin: 0 6px 12px !important; }

._video-type-selector__btn_101pd_4191 {
  background: none;
  margin: 0;
  padding: 0;
  border: 0;
  width: 51px;
  height: 51px;
  text-align: center; }
  ._video-type-selector__btn_101pd_4191:focus, ._video-type-selector__btn_101pd_4191:active {
    outline: 0; }
  ._video-type-selector__btn_101pd_4191:hover ._video-type-selector__btn-icon_101pd_4201 {
    padding: 0;
    border: 2px solid #d6e6fe; }
  ._video-type-selector__btn_101pd_4191._active_101pd_3536 ._video-type-selector__btn-icon_101pd_4201 {
    padding: 0;
    border: 2px solid #116dff; }
  ._video-type-selector__btn-icon_101pd_4201 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 1px;
    margin: 0 0 6px;
    border: 1px solid #dfe5eb;
    border-radius: 4px; }
    ._video-type-selector__btn-icon_101pd_4201 > svg {
      display: block; }

._video-upload-button_101pd_4221._control-upload-button_101pd_4221 > ._control-button_101pd_552
> ._button-content_101pd_3866
._symbol_101pd_552
> ._symbol_101pd_552 {
  padding-right: 0; }

._video-upload-button_101pd_4221._control-upload-button_101pd_4221 > ._control-button_101pd_552 {
  margin: 0 !important; }

._control-text-input-with-button_101pd_4230 {
  position: relative; }
  ._control-text-input-with-button_101pd_4230:hover ._info-icon_101pd_1047 {
    display: inline-block; }
  ._control-text-input-with-button_101pd_4230:hover ._control-text-input_101pd_1607:not(._focused_101pd_2728) > input,
  ._control-text-input-with-button_101pd_4230:hover ._control-text-input_101pd_1607:not(._focused_101pd_2728) > textarea {
    background-color: #e7f0ff;
    color: #3b4057; }
    ._control-text-input-with-button_101pd_4230:hover ._control-text-input_101pd_1607:not(._focused_101pd_2728) > input::placeholder,
    ._control-text-input-with-button_101pd_4230:hover ._control-text-input_101pd_1607:not(._focused_101pd_2728) > textarea::placeholder {
      color: #3b4057; }
  ._control-text-input-with-button_101pd_4230:hover ._control-text-input_101pd_1607:not(._focused_101pd_2728) > input:hover,
  ._control-text-input-with-button_101pd_4230:hover ._control-text-input_101pd_1607:not(._focused_101pd_2728) > textarea:hover {
    background-color: #d6e6fe;
    color: #3b4057; }
  ._control-text-input-with-button_101pd_4230 ._control-text-input_101pd_1607 {
    margin: 12px 0 !important;
    width: 100% !important; }
  ._control-text-input-with-button_101pd_4230 ._control-button_101pd_552 {
    margin: 0 auto 18px !important;
    display: block;
    padding: 7px 24px;
    width: auto;
    min-width: 0;
    line-height: 14px !important;
    font-size: 14px;
    height: 30px; }

._control-text-input-with-fixed-button_101pd_4258 {
  display: flex;
  align-items: center; }
  ._control-text-input-with-fixed-button_101pd_4258 > ._control-text_101pd_1607 {
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    flex-grow: 1;
    color: #3b4057;
    outline: none;
    text-align: left;
    box-sizing: border-box;
    text-overflow: ellipsis;
    border-radius: 4px;
    border: solid 1px #88ccf8;
    background-color: #fff;
    height: 23px;
    padding-left: 15px;
    width: 0; }
  ._control-text-input-with-fixed-button_101pd_4258 > ._control-button_101pd_552 {
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    flex-shrink: 0;
    margin-left: 6px;
    height: 20px;
    border-radius: 12px;
    border-width: 2px;
    line-height: 20px;
    padding-left: 10px;
    padding-right: 9px; }
    ._control-text-input-with-fixed-button_101pd_4258 > ._control-button_101pd_552._disabled_101pd_796 {
      background-color: #bdbdbd; }
  ._control-text-input-with-fixed-button_101pd_4258._invalid_101pd_4295 > ._control-text_101pd_1607 {
    border-color: #d82646; }

._control-thumbnailsSlider_101pd_4298 {
  white-space: nowrap;
  height: 68px;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  background-color: #fff; }
  ._control-thumbnailsSlider_101pd_4298 ._itemsContainer_101pd_4305 {
    visibility: hidden;
    padding-left: 25px;
    padding-right: 25px;
    position: absolute;
    transition-property: left;
    transition-duration: 0.3s;
    top: 50%; }
  ._control-thumbnailsSlider_101pd_4298 ._arrow_101pd_1304 {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.8);
    width: 24px;
    height: 100%;
    cursor: pointer; }
    ._control-thumbnailsSlider_101pd_4298 ._arrow_101pd_1304 span {
      width: 8px;
      height: 8px;
      position: relative;
      top: calc(50% - 10px);
      left: calc(50% - 4px);
      border-top: 1px solid #116dff;
      border-right: 1px solid #116dff;
      display: inline-block; }
    ._control-thumbnailsSlider_101pd_4298 ._arrow_101pd_1304._left_101pd_1152 {
      left: 0; }
      ._control-thumbnailsSlider_101pd_4298 ._arrow_101pd_1304._left_101pd_1152 span {
        transform: rotate(225deg);
        left: 10px; }
    ._control-thumbnailsSlider_101pd_4298 ._arrow_101pd_1304._right_101pd_1150 {
      right: 0; }
      ._control-thumbnailsSlider_101pd_4298 ._arrow_101pd_1304._right_101pd_1150 span {
        transform: rotate(45deg);
        left: 5px; }
  ._control-thumbnailsSlider_101pd_4298 input {
    display: none; }
    ._control-thumbnailsSlider_101pd_4298 input:hover:checked + img, ._control-thumbnailsSlider_101pd_4298 input:checked + img {
      border-radius: 6px;
      border-color: #ff7d38;
      background-color: transparent; }
  ._control-thumbnailsSlider_101pd_4298 img {
    margin-right: 6px;
    border: solid 2px transparent; }
  ._control-thumbnailsSlider_101pd_4298 label {
    height: 100%;
    display: inline-block;
    font-size: 0;
    cursor: pointer; }
    ._control-thumbnailsSlider_101pd_4298 label:hover img {
      border-radius: 6px;
      border-color: #80b1ff;
      background-color: rgba(127, 204, 247, 0.2); }

._proportions-slider_101pd_4357 {
  border-radius: 4px;
  height: 25px;
  background-color: #116dff;
  margin: 13px auto 28px;
  padding: 12px; }
  ._proportions-slider_101pd_4357 > ._column_101pd_4363 {
    background-color: #e7f0ff;
    height: 100%;
    position: relative;
    display: inline-block;
    text-align: center;
    vertical-align: top;
    color: #116dff;
    min-width: 2px; }
    ._proportions-slider_101pd_4357 > ._column_101pd_4363 > ._label_101pd_625 {
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 12px;
      -webkit-font-smoothing: antialiased;
      position: absolute;
      bottom: -32px;
      width: 100%; }
    ._proportions-slider_101pd_4357 > ._column_101pd_4363 > ._divider_101pd_1771 {
      position: absolute;
      left: -6.5px;
      top: 0;
      width: 13px;
      height: 100%;
      background-color: #116dff;
      cursor: col-resize; }
      ._proportions-slider_101pd_4357:hover > ._column_101pd_4363 > ._divider_101pd_1771 {
        background-color: #0057e1; }
      ._proportions-slider_101pd_4357 > ._column_101pd_4363 > ._divider_101pd_1771:hover {
        background-color: #5999ff; }

._label-with-circle-button_101pd_4394 {
  position: relative;
  text-align: left;
  padding: 12px; }
  ._label-with-circle-button_101pd_4394 label {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    line-height: 100%;
    color: #3b4057;
    text-align: left;
    display: block;
    padding: 5px 30px 3px 12px; }
  ._label-with-circle-button_101pd_4394 ._link-to-icon-info_101pd_4409 {
    display: none;
    position: absolute;
    top: 10px;
    right: 10px; }
  ._label-with-circle-button_101pd_4394:hover:not(._disabled_101pd_796) ._link-to-icon-info_101pd_4409 {
    display: inherit; }
  ._label-with-circle-button_101pd_4394 ._container-action_101pd_4416 {
    padding: 0 11px; }
    ._label-with-circle-button_101pd_4394 ._container-action_101pd_4416 ._link_101pd_3492 {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 34px;
      height: 36px; }
      ._label-with-circle-button_101pd_4394 ._container-action_101pd_4416 ._link_101pd_3492::placeholder {
        color: #b6c1cd; }
      ._label-with-circle-button_101pd_4394 ._container-action_101pd_4416 ._link_101pd_3492:hover::placeholder {
        color: #3b4057; }
    ._label-with-circle-button_101pd_4394 ._container-action_101pd_4416 ._validation-icon_101pd_2721 {
      font-size: 0; }
      ._label-with-circle-button_101pd_4394 ._container-action_101pd_4416 ._validation-icon_101pd_2721._validation-icon-success_101pd_2730 {
        border: none;
        background-color: transparent; }
        ._label-with-circle-button_101pd_4394 ._container-action_101pd_4416 ._validation-icon_101pd_2721._validation-icon-success_101pd_2730 svg {
          fill: #25a55a; }
  ._label-with-circle-button_101pd_4394._disabled_101pd_796 label {
    color: #939393; }
  ._label-with-circle-button_101pd_4394._disabled_101pd_796 svg {
    border-color: #bcbcbc;
    background-color: #bcbcbc; }

._control-search_101pd_4441 {
  position: relative; }
  ._control-search-input_101pd_4443 {
    position: relative; }
    ._control-search-input__prefix_101pd_4445 {
      position: absolute;
      left: 14px;
      top: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center; }
    ._control-search-input__suffix_101pd_4453 {
      position: absolute;
      right: 6px;
      top: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      justify-content: center; }
    ._control-search-input__symbol_101pd_4461 {
      height: 100%;
      pointer-events: none; }
      ._control-search-input__symbol_101pd_4461 * {
        fill: #116dff; }
    ._control-search-input_101pd_4443 > ._input-container_101pd_309 > ._input_101pd_309 {
      border: 1px solid #a8caff;
      padding: 0 36px;
      border-radius: 100px;
      height: 30px;
      font-size: 14px; }
    ._control-search-input_101pd_4443 ._control-button_101pd_552._btn-close_101pd_4472 {
      position: relative;
      background-color: #e7f0ff;
      width: 18px;
      height: 18px; }
      ._control-search-input_101pd_4443 ._control-button_101pd_552._btn-close_101pd_4472 svg * {
        fill: #116dff; }
      ._control-search-input_101pd_4443 ._control-button_101pd_552._btn-close_101pd_4472:hover {
        background-color: #e7f0ff; }
        ._control-search-input_101pd_4443 ._control-button_101pd_552._btn-close_101pd_4472:hover svg * {
          fill: #5999ff; }
  ._control-search-options_101pd_4483 {
    position: absolute;
    z-index: 5999;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 6px 6px 0 rgba(22, 45, 61, 0.06), 0 0 18px 0 rgba(22, 45, 61, 0.12);
    max-height: 180px;
    overflow: auto;
    padding: 0;
    margin: 0; }
    ._control-search-options__item_101pd_4496 {
      min-height: 36px;
      padding: 6px 24px;
      margin: 0;
      font-size: 16px;
      line-height: 24px;
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #000624;
      overflow: hidden;
      text-overflow: ellipsis;
      box-sizing: border-box; }
      ._control-search-options__item_101pd_4496._active_101pd_3536 {
        background-color: #d6e6fe;
        color: #000624; }

._colorSpace_101pd_4513 {
  position: relative;
  display: inline-block;
  margin-bottom: 10px; }
  ._colorSpace_101pd_4513 > ._top-section_101pd_4517 {
    height: 123px; }
    ._colorSpace_101pd_4513 > ._top-section_101pd_4517 > ._select-area_101pd_4519 {
      display: inline-block;
      position: relative;
      height: 100%;
      width: 210px;
      cursor: crosshair; }
      ._colorSpace_101pd_4513 > ._top-section_101pd_4517 > ._select-area_101pd_4519 > ._selector-layer_101pd_4525 {
        position: absolute;
        width: 100%;
        height: 100%; }
      ._colorSpace_101pd_4513 > ._top-section_101pd_4517 > ._select-area_101pd_4519 > ._saturation-layer_101pd_4529 {
        background-image: linear-gradient(to right, white, rgba(255, 255, 255, 0)); }
      ._colorSpace_101pd_4513 > ._top-section_101pd_4517 > ._select-area_101pd_4519 > ._brightness-layer_101pd_4531 {
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), black); }
      ._colorSpace_101pd_4513 > ._top-section_101pd_4517 > ._select-area_101pd_4519 > ._color-indicator_101pd_4533 {
        position: absolute;
        width: 10px;
        height: 10px;
        border-radius: 4px; }
        ._colorSpace_101pd_4513 > ._top-section_101pd_4517 > ._select-area_101pd_4519 > ._color-indicator_101pd_4533._bright-background_101pd_4538 {
          box-shadow: 0 0 0 1px #000624; }
        ._colorSpace_101pd_4513 > ._top-section_101pd_4517 > ._select-area_101pd_4519 > ._color-indicator_101pd_4533._dark-background_101pd_4540 {
          box-shadow: 0 0 0 1px #fff; }
    ._add-color-content_101pd_4542 ._colorSpace_101pd_4513 > ._top-section_101pd_4517 {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      overflow: hidden; }
  ._colorSpace_101pd_4513 > ._hue-scale_101pd_4546 {
    width: 100%;
    height: 10px;
    position: relative;
    background-image: linear-gradient(to right, red 0%, #ff4d00 5%, #ff9900 10%, #ffe600 15%, #ccff00 20%, #80ff00 25%, #33ff00 30%, #00ff1a 35%, #00ff66 40%, #00ffb3 45%, cyan 50%, #0066ff 60%, #001aff 65%, #3300ff 70%, #8000ff 75%, #cc00ff 80%, #ff00e6 85%, #ff0099 90%, #ff004d 95%, red 100%); }
    ._colorSpace_101pd_4513 > ._hue-scale_101pd_4546 > ._hue-indicator_101pd_4551 {
      position: absolute;
      top: -3px;
      border-radius: 50%;
      width: 14px;
      height: 14px;
      background-color: #fff;
      box-shadow: 0 2px 1px 0 rgba(43, 86, 114, 0.4);
      box-sizing: border-box; }
    ._colorSpace_101pd_4513 > ._hue-scale_101pd_4546 > ._hue-indicator-drag_101pd_4560 {
      border: 2px solid #fff;
      background-color: transparent; }

._color-format_101pd_2684 > ._color-values-wrapper_101pd_4564 {
  position: relative;
  margin: 18px 17px 12px 17px;
  max-height: 24px; }
  ._color-format_101pd_2684 > ._color-values-wrapper_101pd_4564 > ._color-value-hex_101pd_4568 {
    width: 175px;
    margin: 0 auto 0 auto; }
  ._color-format_101pd_2684 > ._color-values-wrapper_101pd_4564 > ._color-values_101pd_4564 > ._color-value-item_101pd_4571 {
    position: relative;
    display: inline-block;
    width: 33%; }
    ._color-format_101pd_2684 > ._color-values-wrapper_101pd_4564 > ._color-values_101pd_4564 > ._color-value-item_101pd_4571:nth-child(1) {
      text-align: left; }
    ._color-format_101pd_2684 > ._color-values-wrapper_101pd_4564 > ._color-values_101pd_4564 > ._color-value-item_101pd_4571:nth-child(2) {
      text-align: center; }
    ._color-format_101pd_2684 > ._color-values-wrapper_101pd_4564 > ._color-values_101pd_4564 > ._color-value-item_101pd_4571:nth-child(3) {
      text-align: right; }

._palettes-list_101pd_4582 {
  position: relative;
  width: 138px;
  height: 100%;
  text-align: center; }
  ._palettes-list_101pd_4582 > ._palette-options_101pd_4587 {
    display: inline;
    vertical-align: top; }
    ._palettes-list_101pd_4582 > ._palette-options_101pd_4587 > ._palette-option-wrapper_101pd_4590 {
      padding: 3px 0;
      display: inline-block;
      cursor: pointer; }
      ._palettes-list_101pd_4582 > ._palette-options_101pd_4587 > ._palette-option-wrapper_101pd_4590:hover > ._palette-option_101pd_4587 {
        border-color: #d6e6fe;
        transition: border-color 0.4s; }
      ._palettes-list_101pd_4582 > ._palette-options_101pd_4587 > ._palette-option-wrapper_101pd_4590 > ._palette-option_101pd_4587 {
        position: relative;
        display: inline-block;
        height: 24px;
        line-height: 24px;
        border: 1px solid transparent;
        font-size: 0;
        padding: 3px; }
        ._palettes-list_101pd_4582 > ._palette-options_101pd_4587 > ._palette-option-wrapper_101pd_4590 > ._palette-option_101pd_4587._selected_101pd_2256 {
          border-color: #116dff; }
          ._palettes-list_101pd_4582 > ._palette-options_101pd_4587 > ._palette-option-wrapper_101pd_4590 > ._palette-option_101pd_4587._selected_101pd_2256:before {
            position: absolute;
            content: '';
            font-size: initial;
            left: -11px;
            cursor: initial;
            width: 0;
            height: 0;
            border-right: 6px solid #116dff;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            top: 9px; }
        ._palettes-list_101pd_4582 > ._palette-options_101pd_4587 > ._palette-option-wrapper_101pd_4590 > ._palette-option_101pd_4587 > ._palette-option-color_101pd_4619 {
          display: inline-block;
          width: 18px;
          height: 100%; }
          ._palettes-list_101pd_4582 > ._palette-options_101pd_4587 > ._palette-option-wrapper_101pd_4590 > ._palette-option_101pd_4587 > ._palette-option-color_101pd_4619._white-color_101pd_4623 {
            box-sizing: border-box;
            border: 1px solid #ccc; }

._palette-color-option_101pd_4627 {
  display: inline-block;
  vertical-align: top;
  position: relative;
  width: 42px;
  height: 24px; }
  ._palette-color-option_101pd_4627._white-option_101pd_4633 {
    box-sizing: border-box;
    border: 1px solid #ccc; }
  ._palette-color-option_101pd_4627._selectable_101pd_4636 {
    cursor: pointer; }
    ._palette-color-option_101pd_4627._selectable_101pd_4636._option-selected_101pd_4638:after, ._palette-color-option_101pd_4627._selectable_101pd_4636:not(._option-selected_101pd_4638):hover:after, ._palette-color-option_101pd_4627._selectable_101pd_4636._white-option_101pd_4633._option-selected_101pd_4638:after, ._palette-color-option_101pd_4627._selectable_101pd_4636._white-option_101pd_4633:not(._option-selected_101pd_4638):hover:after {
      content: '';
      position: absolute;
      width: 46px;
      height: 28px;
      background-color: inherit; }
    ._palette-color-option_101pd_4627._selectable_101pd_4636._option-selected_101pd_4638:after, ._palette-color-option_101pd_4627._selectable_101pd_4636:not(._option-selected_101pd_4638):hover:after {
      top: -1px;
      left: -2px; }
    ._palette-color-option_101pd_4627._selectable_101pd_4636._white-option_101pd_4633._option-selected_101pd_4638:after, ._palette-color-option_101pd_4627._selectable_101pd_4636._white-option_101pd_4633:not(._option-selected_101pd_4638):hover:after {
      top: -2px;
      left: -3px; }
    ._palette-color-option_101pd_4627._selectable_101pd_4636._option-selected_101pd_4638:after, ._palette-color-option_101pd_4627._selectable_101pd_4636._white-option_101pd_4633:not(._option-selected_101pd_4638):hover:after {
      box-sizing: border-box;
      box-shadow: 0 0 7px 0 rgba(22, 45, 61, 0.44);
      border: solid 1px #fff; }
    ._palette-color-option_101pd_4627._selectable_101pd_4636._option-selected_101pd_4638:after {
      z-index: 2; }
    ._palette-color-option_101pd_4627._selectable_101pd_4636:not(._option-selected_101pd_4638):hover:after {
      z-index: 1; }
    ._palette-color-option_101pd_4627._selectable_101pd_4636._white-option_101pd_4633._option-selected_101pd_4638:after {
      border-color: #ccc; }

._palette-displayer-content_101pd_4661 ._palette-displayer-row_101pd_4661 {
  display: flex;
  margin-bottom: 10px; }
  ._palette-displayer-content_101pd_4661 ._palette-displayer-row_101pd_4661:last-child {
    margin-bottom: 0; }

._palette-displayer-content_101pd_4661._white-option_101pd_4633 {
  box-sizing: border-box;
  border: 1px solid #dfe5eb; }

._palette-displayer-content_101pd_4661 ._palette-color-option_101pd_4627 {
  height: 18px; }
  ._palette-displayer-content_101pd_4661 ._palette-color-option_101pd_4627:first-child {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px; }
  ._palette-displayer-content_101pd_4661 ._palette-color-option_101pd_4627:last-child {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px; }
  ._palette-displayer-content_101pd_4661 ._palette-color-option_101pd_4627._selectable_101pd_4636._option-selected_101pd_4638:after, ._palette-displayer-content_101pd_4661 ._palette-color-option_101pd_4627._selectable_101pd_4636:not(._option-selected_101pd_4638):hover:after {
    content: '';
    position: absolute;
    width: calc(100% + 2px * 2);
    height: calc(100% + 3px * 2);
    background-color: inherit;
    border-radius: 2px;
    top: calc(3px * -1);
    left: calc(2px * -1); }
  ._palette-displayer-content_101pd_4661 ._palette-color-option_101pd_4627._selectable_101pd_4636:not(._option-selected_101pd_4638):hover:after {
    height: calc(100% + 2px * 2);
    top: calc(2px * -1); }

._color-picker-input_101pd_2884 {
  position: relative; }
  ._color-picker-input_101pd_2884 > ._color-picker-wrapper_101pd_4694 {
    width: 30px;
    height: 30px;
    transform: translateZ(0);
    border: 1px solid #d5d5d5;
    box-sizing: border-box;
    border-radius: 4px;
    background-size: 20px 20px;
    background-image: linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc);
    background-position: 5px 5px, 15px 15px;
    position: relative;
    cursor: pointer;
    overflow: hidden; }
    ._color-picker-input_101pd_2884 > ._color-picker-wrapper_101pd_4694._disabled_101pd_796 {
      opacity: 0.4; }
    ._color-picker-input_101pd_2884 > ._color-picker-wrapper_101pd_4694 > ._color-picker-color_101pd_4709 {
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      position: absolute; }
    ._color-picker-input_101pd_2884 > ._color-picker-wrapper_101pd_4694:hover, ._color-picker-input_101pd_2884 > ._color-picker-wrapper_101pd_4694._colorPickerOpen_101pd_4715 {
      border: 2px solid #80b1ff;
      background-position: 4px 4px, 14px 14px; }
  ._color-picker-input_101pd_2884 > ._color-picker-label_101pd_4718 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    color: #3b4057;
    height: 30px;
    line-height: 30px;
    width: 155px;
    cursor: pointer; }
    ._color-picker-input_101pd_2884 > ._color-picker-label_101pd_4718:hover + ._color-picker-wrapper_101pd_4694 {
      border: 2px solid #80b1ff; }
    ._color-picker-input_101pd_2884 > ._color-picker-label_101pd_4718 ~ ._color-picker-wrapper_101pd_4694 {
      position: absolute;
      right: 0;
      top: 0; }
  ._color-picker-input_101pd_2884 > ._divider-long_101pd_1771,
  ._color-picker-input_101pd_2884 > ._rich-text-paragraph_101pd_1780 {
    margin-top: 14px; }
  ._color-picker-input-with-opacity_101pd_2884 ._color-picker-input_101pd_2884 {
    position: absolute;
    right: 0;
    top: 2px; }

._color-picker-input-with-opacity_101pd_2884 {
  position: relative; }
  ._color-picker-input-with-opacity_101pd_2884 > ._color-picker-input-with-opacity-label_101pd_4745 {
    display: block;
    font-size: 14px;
    color: #3b4057;
    overflow: hidden;
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    text-overflow: ellipsis; }
    ._color-picker-input-with-opacity_101pd_2884 > ._color-picker-input-with-opacity-label_101pd_4745._disabled_101pd_796 {
      opacity: 0.5; }
  ._color-picker-input-with-opacity_101pd_2884 > ._color-picker-input-with-opacity-slider_101pd_4754 {
    position: relative; }
  ._color-picker-input-with-opacity_101pd_2884 > ._divider-long_101pd_1771 {
    margin-top: 14px; }
  ._color-picker-input-with-opacity_101pd_2884 > ._rich-text-paragraph_101pd_1780 {
    margin-top: 14px; }

section._tabs_101pd_4761 {
  overflow: hidden;
  position: relative; }
  section._tabs_101pd_4761 > ul._tab-header_101pd_4764 > li._tab-label_101pd_4764 {
    cursor: pointer;
    display: block; }
  section._tabs_101pd_4761 > section._tab-content_101pd_4767 {
    position: relative; }
  section._tabs_101pd_4761._left_101pd_1152 {
    display: flex; }
    section._tabs_101pd_4761._left_101pd_1152 > section._tab-content_101pd_4767 {
      align-self: stretch;
      flex-grow: 1; }
  section._tabs_101pd_4761._top_101pd_2426 > ul._tab-header_101pd_4764 {
    display: block;
    overflow: hidden;
    width: 100%; }
    section._tabs_101pd_4761._top_101pd_2426 > ul._tab-header_101pd_4764 > li._tab-label_101pd_4764 {
      float: left; }
  section._tabs_101pd_4761._radio_101pd_870 > ul._tab-header_101pd_4764 > li._tab-label_101pd_4764 {
    line-height: 16px;
    margin-bottom: 15px;
    padding-left: 28px;
    position: relative; }
    section._tabs_101pd_4761._radio_101pd_870 > ul._tab-header_101pd_4764 > li._tab-label_101pd_4764:before, section._tabs_101pd_4761._radio_101pd_870 > ul._tab-header_101pd_4764 > li._tab-label_101pd_4764:after {
      content: '';
      border-radius: 50%;
      display: block;
      position: absolute; }
    section._tabs_101pd_4761._radio_101pd_870 > ul._tab-header_101pd_4764 > li._tab-label_101pd_4764:before {
      top: calc(50% - 8px);
      border: 1px solid #116dff;
      box-sizing: border-box;
      height: 16px;
      left: 0;
      width: 16px; }
    section._tabs_101pd_4761._radio_101pd_870 > ul._tab-header_101pd_4764 > li._tab-label_101pd_4764._selected_101pd_2256:after {
      top: calc(50% - 6px);
      background-color: #116dff;
      height: 12px;
      left: 2px;
      width: 12px; }
    section._tabs_101pd_4761._radio_101pd_870 > ul._tab-header_101pd_4764 > li._tab-label_101pd_4764:hover:before {
      background-color: #d6e6fe; }

._control-section-divider_101pd_1640._labeled_101pd_1640 {
  position: relative; }
  ._control-section-divider_101pd_1640._labeled_101pd_1640 > ._section-divider-content_101pd_4808 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    cursor: default;
    color: #3b4057; }

._control-section-divider_101pd_1640 ._tooltip-on-ellipsis-content_101pd_4817._section-divider-content_101pd_4808 {
  position: static; }

._tooltip-presenter_101pd_4820 {
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.15), 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 1px 18px 0 rgba(0, 0, 0, 0.08);
  z-index: 5999;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  border-radius: 4px; }
  ._tooltip-presenter_101pd_4820 ._arrow_101pd_1304 {
    transform: rotate(45deg);
    background-color: #fff; }
    ._tooltip-presenter_101pd_4820 ._arrow_101pd_1304:after {
      content: '';
      z-index: -1;
      top: calc(100% - 1px);
      left: 0;
      width: 100%;
      height: 1px;
      box-shadow: 0 2px 4px 0 rgba(22, 45, 61, 0.27); }
    ._tooltip-presenter_101pd_4820 ._arrow_101pd_1304:before {
      content: '';
      z-index: -1;
      top: 0;
      left: calc(100% - 1px);
      width: 1px;
      height: 100%;
      box-shadow: 2px 0 4px 0 rgba(22, 45, 61, 0.27); }
  ._tooltip-presenter_101pd_4820._alignment-bottom_101pd_4847 ._arrow_101pd_1304:after {
    top: 0;
    left: 0;
    box-shadow: 0 -2px 4px 0 rgba(22, 45, 61, 0.27); }
  ._tooltip-presenter_101pd_4820._alignment-bottom_101pd_4847 ._arrow_101pd_1304:before {
    top: 0;
    left: 0;
    box-shadow: -2px 0 4px 0 rgba(22, 45, 61, 0.27); }
  ._tooltip-presenter_101pd_4820._alignment-right_101pd_4855 ._arrow_101pd_1304:after {
    top: calc(100% - 1px);
    left: 0;
    box-shadow: 0 2px 4px 0 rgba(22, 45, 61, 0.27); }
  ._tooltip-presenter_101pd_4820._alignment-right_101pd_4855 ._arrow_101pd_1304:before {
    top: 0;
    left: 0;
    box-shadow: -2px 0 4px 0 rgba(22, 45, 61, 0.27); }
  ._tooltip-presenter_101pd_4820._alignment-left_101pd_4863 ._arrow_101pd_1304:after {
    top: 0;
    left: 0;
    box-shadow: 0 -2px 4px 0 rgba(22, 45, 61, 0.27); }
  ._tooltip-presenter_101pd_4820._alignment-left_101pd_4863 ._arrow_101pd_1304:before {
    top: 0;
    left: calc(100% - 1px);
    box-shadow: 2px 0 4px 0 rgba(22, 45, 61, 0.27); }
  ._tooltip-presenter_101pd_4820 ._content-wrapper_101pd_4871 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    position: relative;
    color: #3b4057; }
  ._tooltip-presenter_101pd_4820._normal-tooltip_101pd_4879 ._content-wrapper_101pd_4871 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    padding: 18px;
    color: #3b4057; }
  ._tooltip-presenter_101pd_4820._small-tooltip_101pd_4887 ._content-wrapper_101pd_4871 {
    padding: 12px; }
  ._tooltip-presenter_101pd_4820._tooltip-transition_101pd_4889 {
    transition: 0.4s cubic-bezier(0.645, 0.045, 0.355, 1) top, 0.4s cubic-bezier(0.645, 0.045, 0.355, 1) left; }
  ._tooltip-presenter_101pd_4820._tooltip-behind-pop-ups_101pd_4891 {
    z-index: 1502; }
  ._tooltip-presenter_101pd_4820._tooltip-behind-pages-panel_101pd_4893 {
    z-index: 1253; }
  ._tooltip-presenter_101pd_4820._tooltip-shake_101pd_4895 {
    animation: _shake-animation_101pd_1 0.3s linear; }
  ._tooltip-presenter_101pd_4820 ._content_101pd_1834 {
    word-wrap: break-word; }

@keyframes _shake-animation_101pd_1 {
  1% {
    transform: translate(-20px); }
  20% {
    transform: translate(10px); }
  40% {
    transform: translate(-5px); }
  60% {
    transform: translate(3px); } }

._quick-tip_101pd_4910 {
  white-space: normal;
  padding: 24px;
  width: 236px; }
  ._quick-tip_101pd_4910 ._close-quick-tip_101pd_4914 {
    position: absolute;
    right: 12px;
    top: 12px;
    height: 7px;
    width: 7px;
    cursor: pointer; }
    ._quick-tip_101pd_4910 ._close-quick-tip_101pd_4914 svg {
      position: absolute; }
  ._quick-tip_101pd_4910 ._text-container_101pd_4923 {
    display: inline-block;
    vertical-align: top;
    padding-left: 12px;
    width: 190px; }
    ._quick-tip_101pd_4910 ._text-container_101pd_4923 ._text_101pd_682 {
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      color: #3b4057;
      display: inline; }
      ._quick-tip_101pd_4910 ._text-container_101pd_4923 ._text_101pd_682._link-action_101pd_4936 {
        cursor: pointer;
        color: #116dff; }
        ._quick-tip_101pd_4910 ._text-container_101pd_4923 ._text_101pd_682._link-action_101pd_4936:hover {
          color: #5999ff; }
    ._quick-tip_101pd_4910 ._text-container_101pd_4923._text-no-image_101pd_4941 {
      padding: 18px; }
  ._quick-tip_101pd_4910 ._quick-tip-image_101pd_4943 {
    display: inline-block;
    vertical-align: top; }
    ._quick-tip_101pd_4910 ._quick-tip-image_101pd_4943 svg {
      width: 34px;
      height: 34px; }

._imageAndTextTooltip_101pd_4950 {
  white-space: normal; }
  ._imageAndTextTooltip_101pd_4950 ._text-container_101pd_4923 {
    padding: 24px; }
    ._imageAndTextTooltip_101pd_4950 ._text-container_101pd_4923 ._title_101pd_1631 {
      font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 18px;
      -webkit-font-smoothing: antialiased;
      color: #3b4057;
      margin-bottom: 12px; }
    ._imageAndTextTooltip_101pd_4950 ._text-container_101pd_4923 ._text_101pd_682 {
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      color: #3b4057;
      display: inline; }
    ._imageAndTextTooltip_101pd_4950 ._text-container_101pd_4923 ._learn-more_101pd_4970 {
      font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
      font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
      font-weight: var(--wbu-font-weight-regular);
      font-size: 14px;
      -webkit-font-smoothing: antialiased;
      cursor: pointer;
      color: #116dff;
      margin-top: 10px;
      display: inline;
      padding-left: 5px; }
      ._imageAndTextTooltip_101pd_4950 ._text-container_101pd_4923 ._learn-more_101pd_4970 :hover {
        text-decoration: underline; }
    ._imageAndTextTooltip_101pd_4950 ._text-container_101pd_4923._text-no-image_101pd_4941 {
      padding: 18px; }
  ._imageAndTextTooltip_101pd_4950 ._image-container_101pd_1118 {
    background-color: #116dff;
    text-align: center;
    left: 0;
    right: 0; }
    ._imageAndTextTooltip_101pd_4950 ._image-container_101pd_1118._upper-image_101pd_4990 {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px; }
    ._imageAndTextTooltip_101pd_4950 ._image-container_101pd_1118._lower-image_101pd_4993 {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px; }
    ._imageAndTextTooltip_101pd_4950 ._image-container_101pd_1118 svg {
      margin-top: 22px;
      margin-bottom: 22px; }
  ._imageAndTextTooltip_101pd_4950 ._close_101pd_1490 {
    float: right;
    cursor: pointer;
    margin: -6px -6px 0 0; }

._icon-and-text_101pd_5004 {
  font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--wbu-font-weight-regular);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  padding: 18px;
  color: #3b4057;
  display: flex;
  align-items: center; }
  ._icon-and-text_101pd_5004 svg {
    margin-right: 10px; }
  ._icon-and-text_101pd_5004 span {
    flex: 1 1 auto;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden; }

._titleBodyAndLinkTooltip_101pd_5022 {
  white-space: normal;
  max-width: 300px;
  padding: 18px; }
  ._titleBodyAndLinkTooltip_101pd_5022 ._title_101pd_1631 {
    font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 18px;
    -webkit-font-smoothing: antialiased;
    color: #3b4057;
    margin-bottom: 6px;
    white-space: nowrap; }
  ._titleBodyAndLinkTooltip_101pd_5022 ._text_101pd_682 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    color: #3b4057; }
  ._titleBodyAndLinkTooltip_101pd_5022 ._link_101pd_3492 {
    font-family: HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
    font-family: var(--wbu-font-stack, HelveticaNeueW01-45Ligh, HelveticaNeueW02-45Ligh, HelveticaNeueW10-45Ligh, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
    font-weight: var(--wbu-font-weight-regular);
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    color: #116dff;
    cursor: pointer;
    margin-top: 11px; }
    ._titleBodyAndLinkTooltip_101pd_5022 ._link_101pd_3492:hover {
      text-decoration: underline; }
  ._titleBodyAndLinkTooltip_101pd_5022 ._close_101pd_1490 {
    float: right;
    cursor: pointer;
    margin: -6px -6px 0 0; }

._titleBodyAndLinkTooltip_101pd_5022._small_101pd_2006 {
  padding: 12px; }
  ._titleBodyAndLinkTooltip_101pd_5022._small_101pd_2006 ._link_101pd_3492 {
    margin-top: 4px; }

._keyboardShortcutTooltip_101pd_5063 ._label_101pd_625 {
  font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--wbu-font-weight-regular);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  color: #3b4057; }

._keyboardShortcutTooltip_101pd_5063 ._shortcut_101pd_5071 {
  font-family: HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif;
  font-family: var(--wbu-font-stack, HelveticaNeueW01-55Roma, HelveticaNeueW02-55Roma, HelveticaNeueW10-55Roma, HelveticaNeueW31, Helvetica Neue, Helvetica, Arial, メイリオ, meiryo, ヒラギノ角ゴ pro w3, hiragino kaku gothic pro, sans-serif);
  font-weight: var(--wbu-font-weight-regular);
  font-size: 12px;
  -webkit-font-smoothing: antialiased;
  color: #868aa5;
  margin-left: 2px; }

._tooltips-layer_101pd_5080 {
  top: 0;
  left: 0; }

._aiTextCreatorEntryPoint_101pd_5084 {
  position: absolute;
  right: 6px;
  bottom: 6px;
  width: 26px;
  height: 26px;
  border-radius: 50% 50% 0 50%;
  background-color: #116dff;
  border: 2px solid white;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.08), 0 6px 10px 0 rgba(0, 0, 0, 0.1), 0 3px 5px -1px rgba(0, 0, 0, 0.15), 0 0 4px 0 rgba(0, 0, 0, 0.1);
  animation: _aiTextCreatorEntryPointAppearance_101pd_1 0.8s ease;
  box-sizing: border-box;
  transition: 0.35s ease;
  transform-origin: bottom right;
  transform: scale(1); }
  ._aiTextCreatorEntryPoint_101pd_5084:has(._aiTextCreatorEntryPoint__icon_101pd_5099) {
    background: url("https://static.parastorage.com/services/santa-resources/dist/editor/rEditor/rootComps/gfpp/sparklesBoldAnimationBackground.v2.svg");
    background-size: contain; }
    ._aiTextCreatorEntryPoint_101pd_5084:has(._aiTextCreatorEntryPoint__icon_101pd_5099):hover {
      background: url("https://static.parastorage.com/services/santa-resources/dist/editor/rEditor/rootComps/gfpp/sparklesBoldAnimationBackgroundHover.svg");
      background-size: contain; }
  ._aiTextCreatorEntryPoint_small_101pd_5105 {
    transform: scale(0.62);
    border-width: 3px; }
    ._aiTextCreatorEntryPoint_small_101pd_5105 ._aiTextCreatorEntryPoint__text_101pd_5108,
    ._aiTextCreatorEntryPoint_small_101pd_5105 ._aiTextCreatorEntryPoint__icon_101pd_5099 {
      opacity: 0;
      transition: opacity 0.35s; }
  ._aiTextCreatorEntryPoint_withBigToSmallAppearance_101pd_5112 {
    animation: _aiTextCreatorEntryPointAppearance_101pd_1 0.8s ease, _aiTextCreatorEntryPointAppearanceScale_101pd_1 1.15s ease; }
    ._aiTextCreatorEntryPoint_withBigToSmallAppearance_101pd_5112 ._aiTextCreatorEntryPoint__text_101pd_5108,
    ._aiTextCreatorEntryPoint_withBigToSmallAppearance_101pd_5112 ._aiTextCreatorEntryPoint__icon_101pd_5099 {
      animation: _aiTextCreatorEntryPointAppearanceText_101pd_1 1.15s ease; }
  ._aiTextCreatorEntryPoint__text_101pd_5108 {
    position: absolute;
    left: 4px;
    top: 6px; }
  ._aiTextCreatorEntryPoint__icon_101pd_5099 {
    position: absolute;
    left: 2px;
    top: 3px; }
  ._aiTextCreatorEntryPoint__wrapper_101pd_5125 {
    position: absolute;
    z-index: 1;
    right: 0;
    bottom: 0;
    width: 38px;
    height: 37px; }
    ._aiTextCreatorEntryPoint__wrapper_cursorPointer_101pd_5132 {
      cursor: pointer; }
    ._aiTextCreatorEntryPoint__wrapper_101pd_5125:hover ._aiTextCreatorEntryPoint_withHover_101pd_5134 {
      border: 2px solid white;
      transform: scale(1); }
      ._aiTextCreatorEntryPoint__wrapper_101pd_5125:hover ._aiTextCreatorEntryPoint_withHover_101pd_5134 ._aiTextCreatorEntryPoint__text_101pd_5108,
      ._aiTextCreatorEntryPoint__wrapper_101pd_5125:hover ._aiTextCreatorEntryPoint_withHover_101pd_5134 ._aiTextCreatorEntryPoint__icon_101pd_5099 {
        opacity: 1; }
    ._aiTextCreatorEntryPoint__wrapper_101pd_5125 svg * {
      fill: #fff; }

@keyframes _aiTextCreatorEntryPointAppearance_101pd_1 {
  0% {
    opacity: 0; }
  12.5% {
    opacity: 0; }
  100% {
    opacity: 1; } }

@keyframes _aiTextCreatorEntryPointAppearanceScale_101pd_1 {
  0% {
    transform: scale(1);
    border-width: 2px; }
  70% {
    transform: scale(1);
    border-width: 2px; }
  100% {
    transform: scale(0.62);
    border-width: 3px; } }

@keyframes _aiTextCreatorEntryPointAppearanceText_101pd_1 {
  0% {
    opacity: 1; }
  70% {
    opacity: 1; }
  100% {
    opacity: 0; } }

._dropdown_101pd_349 {
  position: relative;
  z-index: 1;
  max-width: 100%; }
  ._dropdown__header_101pd_5174 {
    display: flex;
    gap: 4.5px;
    height: 24px;
    padding: 3px 3px 3px 12px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #a8caff;
    background: white;
    box-sizing: border-box;
    cursor: pointer; }
    ._dropdown__header_101pd_5174:hover {
      border-color: #5999ff; }
  ._dropdown__text_101pd_5188 {
    min-width: calc(100% - 39px); }
  ._dropdown__icon_101pd_5190 {
    display: flex; }
  ._dropdown__list_101pd_5192 {
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;
    position: fixed;
    top: 100%;
    left: 0;
    background-color: white;
    border-top: none;
    border-radius: 0 0 5px 5px;
    display: none;
    box-sizing: border-box;
    max-height: 174px;
    overflow-y: auto;
    z-index: 1;
    box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.12), 0 4px 10px -2px rgba(0, 0, 0, 0.08), 0 8px 20px 0 rgba(0, 0, 0, 0.08); }
    ._dropdown__list_101pd_5192._dividers_removed_101pd_5209 {
      padding: 6px 0; }
    ._dropdown__list_101pd_5192 li {
      display: flex;
      cursor: pointer;
      height: 25px;
      padding: 3px 12px;
      justify-content: left;
      align-items: center;
      box-sizing: border-box; }
      ._dropdown__list_101pd_5192 li:hover {
        background-color: #116dff; }
        ._dropdown__list_101pd_5192 li:hover div {
          color: white; }
    ._dropdown__list_101pd_5192:not(._dividers_removed_101pd_5209) li:not(:last-child) {
      border-bottom: 1px solid #dfe5eb; }
  ._dropdown_open_101pd_5225 {
    z-index: 2; }
    ._dropdown_open_101pd_5225 ._dropdown__header_101pd_5174 {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0; }
    ._dropdown_open_101pd_5225 ._dropdown__list_101pd_5192 {
      display: block; }
